<template>
  <div
    class="pdm-gestao"
    :class="{ 'pdm-gestao--bloqueado': processandoOkr || salvandoOkrs }"
  >
    <div
      v-if="processandoOkr || salvandoOkrs"
      class="overlay-processando-okr"
      role="alert"
      aria-live="assertive"
    >
      <div class="overlay-processando-okr__conteudo">
        <span class="overlay-processando-okr__spinner" aria-hidden="true"></span>
        <p>
          {{
            salvandoOkrs
              ? "Salvando OKRs..."
              : "Processando cadastro de OKR..."
          }}
        </p>
      </div>
    </div>
    <header class="cabecalho">
      <div>
        <h2>Planos de Desenvolvimento Municipal</h2>
        <p>
          Cadastre o PDM do município, organize as Áreas Chave da Gestão
          Municipal e conecte os projetos estratégicos.
        </p>
      </div>
      <div class="indicadores">
        <span class="tag">{{ pdms.length }} PDM(s) ativos</span>
        <span class="tag secundario"
          >{{ totalProjetos }} projetos vinculados</span
        >
      </div>
    </header>

    <section
      v-if="alerta.mensagem"
      class="alerta"
      :data-tipo="alerta.tipo"
      role="status"
      aria-live="polite"
    >
      {{ alerta.mensagem }}
    </section>

    <div class="filtros-container">
      <div class="filtros-header">
        <div>
          <h3>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 7h18M10 11h4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M21 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
            Filtros
          </h3>
          <p>Refine a visualização dos PDMs por critérios específicos</p>
        </div>
        <button
          type="button"
          class="filtros-clear"
          @click="limparFiltros"
          v-if="municipioFiltro.municipio || mostrarTodosMunicipios"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 18L18 6M6 6l12 12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Limpar filtros
        </button>
      </div>
      <div class="filtros-grid">
        <div class="filtro-campo">
          <label for="filtro-municipio">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <circle
                cx="12"
                cy="10"
                r="3"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
            Município
          </label>
          <div class="filtro-input-wrapper">
            <ComboboxMunicipio
              ref="filtroMunicipio"
              :filter="municipioFiltro"
              class="combobox-municipio"
              clearable
              :disabled="mostrarTodosMunicipios"
              @changeCity="aoAlterarMunicipio"
              :noLabel="true"
            />
          </div>
        </div>
        <div class="filtro-campo filtro-campo-checkbox">
          <small class="checkbox-description"
            >Visualizar PDMs de todas as cidades</small
          >
          <label class="checkbox-label">
            <input
              type="checkbox"
              v-model="mostrarTodosMunicipios"
              @change="alternarListaTodosMunicipios"
            />
            <span class="checkbox-text">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 6L9 17l-5-5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Mostrar todos os municípios
            </span>
          </label>
        </div>
      </div>
    </div>

    <section
      class="conteudo"
      v-if="mostrarTodosMunicipios || filtros.idMunicipio"
    >
      <div class="area-pdms">
        <div class="painel-pdms-novo">
          <div class="pdms-section">
            <div class="lista-header">
              <h3>
                {{
                  mostrarTodosMunicipios
                    ? "PDMs cadastrados"
                    : "PDMs do município"
                }}
              </h3>
              <small
                >Selecione para visualizar as áreas chave e projetos.</small
              >
            </div>

            <div v-if="filtros.idMunicipio" class="novo-pdm-container">
              <button
                v-if="!exibirFormularioNovoPdm"
                type="button"
                class="btn-novo-pdm"
                @click="abrirFormularioNovoPdm"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 5v14M5 12h14"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="btn-content">
                  <span class="btn-title">Adicionar Novo PDM</span>
                  <small class="btn-description"
                    >Cadastre um novo Plano de Desenvolvimento Municipal</small
                  >
                </div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 18l6-6-6-6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <form
                v-if="exibirFormularioNovoPdm"
                class="novo-pdm-section"
                @submit.prevent="criarNovoPdm"
              >
                <div class="form-header">
                  <h4>Novo PDM</h4>
                  <button
                    type="button"
                    class="btn-fechar"
                    @click="fecharFormularioNovoPdm"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 6L6 18M6 6l12 12"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div class="form-campos">
                  <label class="campo-form">
                    Nome
                    <input
                      v-model="novoPdm.nome"
                      type="text"
                      placeholder="Ex: PDM 2025-2028"
                      required
                    />
                  </label>
                  <div class="periodo-campos">
                    <label class="campo-form">
                      Data de Início
                      <input
                        v-model="novoPdm.periodoInicio"
                        type="date"
                        required
                        :class="{ invalido: erros.periodoNovoPdm }"
                        @input="limparErroPeriodo('novo')"
                      />
                    </label>
                    <label class="campo-form">
                      Data de Fim
                      <input
                        v-model="novoPdm.periodoFim"
                        type="date"
                        required
                        :class="{ invalido: erros.periodoNovoPdm }"
                        @input="limparErroPeriodo('novo')"
                      />
                    </label>
                  </div>
                </div>
                <div class="form-actions">
                  <button
                    type="button"
                    class="btn-cancelar"
                    @click="fecharFormularioNovoPdm"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    class="btn-adicionar"
                    :disabled="carregando"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 5v14M5 12h14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {{ carregando ? "Adicionando..." : "Adicionar PDM" }}
                  </button>
                </div>
              </form>
            </div>

            <div v-else class="select-municipio">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <circle
                  cx="12"
                  cy="10"
                  r="3"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
              <p>Selecione um município para cadastrar um novo PDM.</p>
            </div>
            <div class="divider"></div>

            <!-- Loading da listagem de PDMs -->
            <div v-if="carregando && !pdms.length" class="loading-pdms">
              <div class="loading-spinner-container">
                <div class="loading-spinner">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="spinner"
                  >
                    <path
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <p class="loading-text">Carregando PDMs...</p>
                <small class="loading-subtext"
                  >Aguarde enquanto buscamos os dados</small
                >
              </div>
            </div>

            <ul class="pdms" v-else-if="pdms.length">
              <li
                v-for="pdm in pdms"
                :key="obterIdPdm(pdm)"
                class="pdm-item"
                :class="{
                  ativo:
                    detalhePdm && obterIdPdm(pdm) === obterIdPdm(detalhePdm),
                  expandido:
                    detalhePdm && obterIdPdm(pdm) === obterIdPdm(detalhePdm),
                }"
              >
                <div class="pdm-header" @click="selecionarPdm(pdm)">
                  <div class="pdm-info">
                    <h5 class="pdm-nome">{{ pdm.nome || pdm.titulo }}</h5>
                    <div class="pdm-meta">
                      <span class="pdm-periodo">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                          <line
                            x1="16"
                            y1="2"
                            x2="16"
                            y2="6"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                          <line
                            x1="8"
                            y1="2"
                            x2="8"
                            y2="6"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                          <line
                            x1="3"
                            y1="10"
                            x2="21"
                            y2="10"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                        </svg>
                        {{ formatarPeriodo(pdm.periodoInicio, pdm.periodoFim) }}
                      </span>
                      <span
                        v-if="pdm.status"
                        class="pdm-status"
                        :data-status="pdm.status?.toLowerCase()"
                      >
                        {{ pdm.status }}
                      </span>
                    </div>
                  </div>
                  <div class="pdm-actions">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      :class="{
                        rotated:
                          detalhePdm &&
                          obterIdPdm(pdm) === obterIdPdm(detalhePdm),
                      }"
                    >
                      <path
                        d="M9 18l6-6-6-6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div v-if="mostrarTodosMunicipios" class="pdm-municipio">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <circle
                      cx="12"
                      cy="10"
                      r="3"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                  </svg>
                  {{ pdm.nomeMunicipio || "Município não informado" }}
                </div>

                <!-- Conteúdo expandido do PDM -->
                <transition name="expand">
                  <!-- Loading quando está carregando este PDM específico -->
                  <div
                    v-if="pdmCarregandoId === obterIdPdm(pdm)"
                    class="pdm-detalhe"
                  >
                    <div class="loading-container">
                      <div class="loading-spinner">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="spinner"
                        >
                          <path
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            fill="currentColor"
                          />
                        </svg>
                        <span>Carregando detalhes...</span>
                      </div>
                    </div>
                  </div>

                  <!-- Conteúdo normal quando carregado -->
                  <div
                    v-else-if="
                      detalhePdm && obterIdPdm(pdm) === obterIdPdm(detalhePdm)
                    "
                    class="pdm-detalhe"
                  >
                    <div class="pdm-detalhe-content-wrapper">
                      <div class="pdm-detalhe-header">
                        <div class="pdm-detalhe-info">
                          <span class="badge"
                            >{{ eixosOrdenados.length }} área(s)</span
                          >
                        </div>
                        <div class="acoes-pdm">
                          <button
                            type="button"
                            class="botao-acao"
                            @click.stop="abrirAcaoPdm('editar')"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Editar plano
                          </button>
                          <button
                            type="button"
                            class="botao-acao perigoso"
                            :disabled="!podeExcluirPdm"
                            @click.stop="abrirAcaoPdm('excluir')"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <polyline
                                points="3,6 5,6 21,6"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <line
                                x1="10"
                                y1="11"
                                x2="10"
                                y2="17"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <line
                                x1="14"
                                y1="11"
                                x2="14"
                                y2="17"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Excluir plano
                          </button>
                        </div>
                      </div>

                      <div class="pdm-detalhe-content">
                        <section class="eixos-inline">
                          <div class="titulo-secao">
                            <h4>Áreas Chave da Gestão Municipal</h4>
                            <button
                              type="button"
                              :disabled="
                                processandoEixo || !podeCriarNovaAreaChave
                              "
                              @click.stop="alternarFormularioNovoEixo"
                              class="btn-nova-area"
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <line
                                  x1="12"
                                  y1="5"
                                  x2="12"
                                  y2="19"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <line
                                  x1="5"
                                  y1="12"
                                  x2="19"
                                  y2="12"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Nova área chave
                            </button>
                          </div>

                          <!-- Lista de Áreas Chave com Design Premium -->
                          <div class="areas-premium-container">
                            <div
                              v-for="(eixo, index) in eixosOrdenados"
                              :key="obterIdEixo(eixo)"
                              class="area-card"
                              :class="{
                                ativo: eixoExpandidoId === obterIdEixo(eixo),
                              }"
                            >
                              <!-- Header da Área Chave -->
                              <div
                                class="area-card-header"
                                @click="toggleOkrsEixo(eixo)"
                              >
                                <div class="area-title-section">
                                  <strong>{{
                                    eixo.nome || eixo.titulo
                                  }}</strong>
                                  <div class="area-meta-info">
                                    <span class="badge secundario">
                                      {{ (eixo.projetos || []).length }}
                                      projeto(s)
                                    </span>
                                    <v-icon
                                      :class="{
                                        rotated:
                                          eixoExpandidoId === obterIdEixo(eixo),
                                      }"
                                      class="expand-icon"
                                      size="24"
                                    >
                                      {{
                                        eixoExpandidoId === obterIdEixo(eixo)
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      }}
                                    </v-icon>
                                  </div>
                                </div>
                              </div>

                              <p
                                v-if="eixo.descricao"
                                class="area-card-description"
                              >
                                {{ eixo.descricao }}
                              </p>
                              <p
                                v-else
                                class="area-card-description"
                                style="font-style: italic; opacity: 0.7"
                              >
                                Sem descrição cadastrada
                              </p>

                              <!-- Ações da Área -->
                              <div class="area-card-actions">
                                <button
                                  class="btn-action"
                                  :disabled="processandoEixo"
                                  @click.stop="iniciarEdicaoEixo(eixo)"
                                >
                                  <v-icon size="16" left
                                    >mdi-pencil-outline</v-icon
                                  >
                                  Editar
                                </button>
                                <button
                                  class="btn-action btn-danger"
                                  :disabled="processandoEixo"
                                  @click.stop="
                                    abrirConfirmacaoExcluirEixo(eixo)
                                  "
                                >
                                  <v-icon size="16" left
                                    >mdi-delete-outline</v-icon
                                  >
                                  Excluir
                                </button>
                              </div>

                              <!-- Seção OKRs Expansível com Design Premium -->
                              <transition name="okrs-premium-expand">
                                <div
                                  v-if="eixoExpandidoId === obterIdEixo(eixo)"
                                  class="area-okrs-premium-section"
                                >
                                  <div class="okrs-premium-header">
                                    <div class="okrs-title-premium">
                                      <div class="okr-icon-wrapper">
                                        <v-icon size="28" color="white"
                                          >mdi-target</v-icon
                                        >
                                      </div>
                                      <div class="okrs-title-text">
                                        <h4>Objetivos e Resultados Chave</h4>
                                        <p>{{ eixo.nome || eixo.titulo }}</p>
                                      </div>
                                    </div>
                                    <div class="okrs-premium-actions">
                                      <button
                                        class="btn-okr-action primary"
                                        :disabled="salvandoOkrs || processandoOkr"
                                        @click="
                                          adicionarObjetivoOkrParaEixo(eixo)
                                        "
                                      >
                                        <v-icon
                                          size="18"
                                          left
                                          style="color: #fff"
                                          >mdi-plus-circle</v-icon
                                        >
                                        Novo Objetivo
                                      </button>
                                      <button
                                        class="btn-okr-action success"
                                        :disabled="salvandoOkrs || processandoOkr"
                                        @click="salvarOkrsEixo"
                                      >
                                        <v-icon
                                          size="18"
                                          left
                                          style="color: #fff"
                                          >mdi-content-save</v-icon
                                        >
                                        {{
                                          salvandoOkrs
                                            ? "Salvando..."
                                            : "Salvar OKRs"
                                        }}
                                      </button>
                                    </div>
                                  </div>

                                  <div
                                    v-if="!obterOkrsEixo(eixo).length"
                                    class="okrs-empty-state"
                                  >
                                    <v-icon size="48" color="grey lighten-1"
                                      >mdi-target</v-icon
                                    >
                                    <p>
                                      Nenhum objetivo estratégico cadastrado
                                      para esta área chave.
                                    </p>
                                    <v-btn
                                      outlined
                                      color="primary"
                                      :disabled="salvandoOkrs || processandoOkr"
                                      @click="
                                        adicionarObjetivoOkrParaEixo(eixo)
                                      "
                                    >
                                      <v-icon left>mdi-plus</v-icon>
                                      Criar primeiro objetivo
                                    </v-btn>
                                  </div>

                                  <div
                                    v-for="(okr, indice) in obterOkrsEixo(eixo)"
                                    :key="okr.id || okr.clientId"
                                    class="okr-card"
                                    @blur.capture="agendarAutosaveOkrsEixo(okr.eixoId, $event)"
                                    @change.capture="agendarAutosaveOkrsEixo(okr.eixoId, $event)"
                                  >
                                    <div class="okr-header-card">
                                      <div class="okr-field-group">
                                        <v-textarea
                                          ref="descricoesObjetivosOkr"
                                          v-model.trim="okr.titulo"
                                          label="Objetivo estratégico"
                                          placeholder="Ex: Fortalecer o empreendedorismo local"
                                          outlined
                                          dense
                                          rows="2"
                                          auto-grow
                                          no-resize
                                          class="okr-input-large"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @input="marcarOkrsPendentes(okr.eixoId)"
                                        ></v-textarea>

                                        <v-select
                                          v-model="okr.status"
                                          :items="okrStatusOpcoes"
                                          label="Status"
                                          outlined
                                          dense
                                          class="okr-select-status"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @change="marcarOkrsPendentes(okr.eixoId)"
                                        ></v-select>

                                        <v-btn
                                          small
                                          color="error"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @click="removerObjetivoOkr(indice)"
                                          class="okr-remove-btn"
                                        >
                                          <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                      </div>
                                    </div>

                                    <!-- Resultados Chave -->
                                    <div class="okr-resultados">
                                      <div class="okr-resultados-header">
                                        <h6>
                                          <v-icon size="18" class="mr-2"
                                            >mdi-flag-checkered</v-icon
                                          >
                                          Resultados chave
                                        </h6>
                                        <v-btn
                                          color="primary"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @click="adicionarResultadoOkr(okr)"
                                        >
                                          <v-icon left>mdi-plus</v-icon>
                                          Adicionar
                                        </v-btn>
                                      </div>

                                      <div
                                        v-for="(
                                          resultado, idx
                                        ) in okr.resultados"
                                        :key="
                                          resultado.id || resultado.clientId
                                        "
                                        class="okr-resultado-item"
                                      >
                                        <v-textarea
                                          ref="descricoesResultadosOkr"
                                          v-model.trim="resultado.titulo"
                                          label="Descrição do resultado"
                                          placeholder="Descreva o resultado chave"
                                          outlined
                                          dense
                                          rows="2"
                                          auto-grow
                                          no-resize
                                          class="resultado-titulo"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @input="marcarOkrsPendentes(okr.eixoId)"
                                        ></v-textarea>

                                        <v-select
                                          v-model="resultado.status"
                                          :items="okrStatusOpcoes"
                                          label="Status"
                                          outlined
                                          dense
                                          class="resultado-status"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @change="marcarOkrsPendentes(okr.eixoId)"
                                        ></v-select>

                                        <v-text-field
                                          v-model.number="resultado.percentual"
                                          label="Progresso (%)"
                                          type="number"
                                          min="0"
                                          max="100"
                                          outlined
                                          dense
                                          suffix="%"
                                          class="resultado-percentual"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @input="marcarOkrsPendentes(okr.eixoId)"
                                        ></v-text-field>

                                        <v-btn
                                          small
                                          color="error"
                                          :disabled="salvandoOkrs || processandoOkr"
                                          @click="removerResultadoOkr(okr, idx)"
                                        >
                                          <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                      </div>
                                    </div>

                                    <!-- Mensuração -->
                                    <div class="okr-mensuracao ml-2">
                                      <div class="okr-mensuracao-info">
                                        <span class="mensuracao-label">
                                          <v-icon size="18" class="mr-1"
                                            >mdi-calendar-clock</v-icon
                                          >
                                          Última mensuração:
                                          {{ obterDataUltimaMensuracao(okr) }}
                                        </span>
                                        <v-btn
                                          color="primary"
                                          @click="abrirMensuracaoOkr(okr)"
                                          class="ml-4"
                                        >
                                          <v-icon left>mdi-chart-line</v-icon>
                                          Nova mensuração
                                        </v-btn>
                                      </div>

                                      <div
                                        v-if="
                                          obterHistoricoMensuracoesOkr(okr)
                                            .length
                                        "
                                        class="okr-historico-mensuracoes"
                                      >
                                        <div class="okr-historico-titulo">
                                          <v-icon size="18"
                                            >mdi-history</v-icon
                                          >
                                          Histórico e evolução
                                        </div>
                                        <div
                                          v-for="registro in obterHistoricoMensuracoesOkr(
                                            okr
                                          ).slice(0, 6)"
                                          :key="registro.chave"
                                          class="okr-historico-item"
                                        >
                                          <div>
                                            <strong>{{
                                              formatarDataOkr(registro.data)
                                            }}</strong>
                                            <small>{{
                                              registro.resultadoTitulo
                                            }}</small>
                                          </div>
                                          <div class="okr-historico-valores">
                                            <span>{{
                                              formatarPercentual(
                                                registro.percentual
                                              )
                                            }}</span>
                                            <small
                                              v-if="
                                                registro.evolucao !== null &&
                                                registro.evolucao !== undefined
                                              "
                                            >
                                              {{
                                                formatarEvolucaoOkr(
                                                  registro.evolucao
                                                )
                                              }}
                                            </small>
                                          </div>
                                        </div>
                                      </div>

                                      <v-expand-transition>
                                        <div
                                          v-if="
                                            mensuracaoAbertaId ===
                                            obterChaveOkr(okr)
                                          "
                                          class="okr-mensuracao-form ml-2"
                                        >
                                          <h6 class="mensuracao-form-title">
                                            <v-icon class="ml-2"
                                              >mdi-chart-line</v-icon
                                            >
                                            Registrar nova mensuração
                                          </h6>

                                          <div class="mensuracao-items">
                                            <div
                                              v-for="resultado in okr.resultados"
                                              :key="
                                                resultado.id ||
                                                resultado.clientId
                                              "
                                              class="mensuracao-item"
                                            >
                                              <v-text-field
                                                v-model.number="
                                                  mensuracaoRascunho[
                                                    obterChaveResultado(
                                                      resultado
                                                    )
                                                  ]
                                                "
                                                :label="
                                                  resultado.titulo ||
                                                  'Resultado chave'
                                                "
                                                type="number"
                                                min="0"
                                                max="100"
                                                outlined
                                                dense
                                                suffix="%"
                                                placeholder="0"
                                              ></v-text-field>
                                            </div>
                                          </div>

                                          <div class="mensuracao-actions">
                                            <v-btn
                                              outlined
                                              @click="cancelarMensuracaoOkr"
                                              class="mr-2"
                                            >
                                              Cancelar
                                            </v-btn>
                                            <v-btn
                                              color="primary"
                                              @click="salvarMensuracaoOkr(okr)"
                                            >
                                              <v-icon left
                                                >mdi-content-save</v-icon
                                              >
                                              Salvar mensuração
                                            </v-btn>
                                          </div>
                                        </div>
                                      </v-expand-transition>
                                    </div>
                                  </div>
                                </div>
                              </transition>
                            </div>
                          </div>

                          <v-data-table
                            :headers="areasTableHeaders"
                            :items="eixosOrdenados"
                            :items-per-page="5"
                            dense
                            class="areas-data-table"
                            item-key="id"
                            @click:row="selecionarEixo"
                            :no-data-text="'Nenhuma área chave cadastrada'"
                            :footer-props="{
                              'items-per-page-text': 'Linhas por página:',
                              'items-per-page-options': [5, 10, 15, -1],
                              'items-per-page-all-text': 'Todos',
                              'page-text': '{0}-{1} de {2}',
                              'prev-icon': 'mdi-chevron-left',
                              'next-icon': 'mdi-chevron-right',
                            }"
                          >
                            <template v-slot:item.nome="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <strong
                                    v-bind="attrs"
                                    v-on="on"
                                    class="text-truncate d-inline-block"
                                    style="max-width: 200px"
                                  >
                                    {{ item.nome || item.titulo }}
                                  </strong>
                                </template>
                                <span>{{ item.nome || item.titulo }}</span>
                              </v-tooltip>
                            </template>

                            <template v-slot:item.descricao="{ item }">
                              <v-tooltip bottom v-if="item.descricao">
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    v-bind="attrs"
                                    v-on="on"
                                    class="text-truncate d-inline-block"
                                    style="max-width: 250px"
                                  >
                                    {{ item.descricao }}
                                  </span>
                                </template>
                                <span>{{ item.descricao }}</span>
                              </v-tooltip>
                              <span v-else class="grey--text"
                                >Sem descrição cadastrada</span
                              >
                            </template>

                            <template v-slot:item.projetos="{ item }">
                              <v-chip
                                small
                                color="grey lighten-3"
                                text-color="grey darken-2"
                              >
                                {{ (item.projetos || []).length }} projeto(s)
                              </v-chip>
                            </template>

                            <template v-slot:item.acoes="{ item }">
                              <div class="d-flex justify-center">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      outlined
                                      color="success"
                                      :disabled="processandoEixo"
                                      @click.stop="abrirPainelOkrDoEixo(item)"
                                      v-bind="attrs"
                                      v-on="on"
                                      class="ma-1"
                                    >
                                      <v-icon size="16" left>mdi-target</v-icon>
                                      OKRs
                                    </v-btn>
                                  </template>
                                  <span>Gerenciar OKRs</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      outlined
                                      color="primary"
                                      :disabled="processandoEixo"
                                      @click.stop="iniciarEdicaoEixo(item)"
                                      v-bind="attrs"
                                      v-on="on"
                                      class="ma-1"
                                    >
                                      <v-icon size="16" left
                                        >mdi-pencil-outline</v-icon
                                      >
                                      Editar
                                    </v-btn>
                                  </template>
                                  <span>Editar área chave</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      outlined
                                      color="error"
                                      :disabled="processandoEixo"
                                      @click.stop="
                                        abrirConfirmacaoExcluirEixo(item)
                                      "
                                      v-bind="attrs"
                                      v-on="on"
                                      class="ma-1"
                                    >
                                      <v-icon size="16" left
                                        >mdi-delete-outline</v-icon
                                      >
                                      Excluir
                                    </v-btn>
                                  </template>
                                  <span>Excluir área chave</span>
                                </v-tooltip>
                              </div>
                            </template>
                          </v-data-table>

                          <!-- Formulário Nova Área -->
                          <transition name="fade">
                            <div
                              v-if="exibirFormularioEixo"
                              class="nova-area-container"
                              @click.stop
                            >
                              <div class="nova-area-header">
                                <div class="nova-area-icon">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="3"
                                      y="3"
                                      width="18"
                                      height="18"
                                      rx="2"
                                      ry="2"
                                      stroke="currentColor"
                                      stroke-width="2"
                                    />
                                    <line
                                      x1="9"
                                      y1="12"
                                      x2="15"
                                      y2="12"
                                      stroke="currentColor"
                                      stroke-width="2"
                                    />
                                    <line
                                      x1="12"
                                      y1="9"
                                      x2="12"
                                      y2="15"
                                      stroke="currentColor"
                                      stroke-width="2"
                                    />
                                  </svg>
                                </div>
                                <div class="nova-area-title">
                                  <h4>Nova área chave</h4>
                                  <p>
                                    Defina uma área estratégica da gestão
                                    municipal
                                  </p>
                                </div>
                              </div>

                              <form
                                class="nova-area-form"
                                @submit.prevent="criarNovoEixo"
                              >
                                <div class="nova-area-fields">
                                  <div class="form-field">
                                    <label class="form-label">
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M22 11.08V12a10 10 0 1 1-5.93-9.14"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <polyline
                                          points="22,4 12,14.01 9,11.01"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      Área chave
                                    </label>
                                    <select
                                      v-model.trim="novoEixo.nome"
                                      required
                                      :disabled="!areasChaveDisponiveis.length"
                                      class="form-select"
                                    >
                                      <option value="">
                                        Selecione uma área...
                                      </option>
                                      <option
                                        v-for="nome in areasChaveDisponiveis"
                                        :key="nome"
                                        :value="nome"
                                      >
                                        {{ nome }}
                                      </option>
                                    </select>
                                  </div>

                                  <div class="form-field">
                                    <label class="form-label">
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <polyline
                                          points="14,2 14,8 20,8"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <line
                                          x1="16"
                                          y1="13"
                                          x2="8"
                                          y2="13"
                                          stroke="currentColor"
                                          stroke-width="2"
                                        />
                                        <line
                                          x1="16"
                                          y1="17"
                                          x2="8"
                                          y2="17"
                                          stroke="currentColor"
                                          stroke-width="2"
                                        />
                                      </svg>
                                      Descrição (opcional)
                                    </label>
                                    <textarea
                                      v-model="novoEixo.descricao"
                                      rows="3"
                                      placeholder="Contextualize o foco desta área chave da gestão municipal..."
                                      class="form-textarea"
                                    ></textarea>
                                  </div>
                                </div>

                                <div
                                  v-if="!areasChaveDisponiveis.length"
                                  class="warning-message-inline"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <line
                                      x1="12"
                                      y1="9"
                                      x2="12"
                                      y2="13"
                                      stroke="currentColor"
                                      stroke-width="2"
                                    />
                                    <line
                                      x1="12"
                                      y1="17"
                                      x2="12.01"
                                      y2="17"
                                      stroke="currentColor"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  <span
                                    >Todas as áreas chave já foram cadastradas
                                    neste PDM</span
                                  >
                                </div>

                                <div class="nova-area-actions">
                                  <button
                                    type="button"
                                    class="btn-secondary btn-cancel"
                                    @click="alternarFormularioNovoEixo"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    Cancelar
                                  </button>
                                  <button
                                    type="submit"
                                    :disabled="
                                      carregando ||
                                      processandoEixo ||
                                      !areasChaveDisponiveis.length
                                    "
                                    class="btn-primary btn-create"
                                  >
                                    <svg
                                      v-if="!(carregando || processandoEixo)"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M20 6L9 17l-5-5"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    <svg
                                      v-else
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="spinner"
                                    >
                                      <path
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                    {{
                                      carregando || processandoEixo
                                        ? "Cadastrando..."
                                        : "Cadastrar área chave"
                                    }}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </transition>
                        </section>
                      </div>
                    </div>
                  </div>
                </transition>
              </li>
            </ul>

            <div v-else-if="!carregando" class="empty-state">
              <p>Nenhum PDM cadastrado ainda.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="eixoSelecionado && exibirPainelOkr"
      class="formulario okr-painel"
    >
      <header class="okr-painel__cabecalho">
        <h4>OKRs da área chave</h4>
        <p>
          Área selecionada:
          <strong>{{ eixoSelecionado.nome || eixoSelecionado.titulo }}</strong>
        </p>
        <p class="okr-painel__ajuda">
          Os objetivos e KRs cadastrados aparecem na lista abaixo.
        </p>
      </header>

      <p v-if="mensagemOkr" class="okr-alerta">{{ mensagemOkr }}</p>

      <section class="okr-cadastro-card">
        <button
          type="button"
          class="botao-acao"
          :disabled="processandoOkr || okrApiIndisponivel"
          @click="alternarFormularioObjetivo"
        >
          {{
            exibirFormularioNovoObjetivo
              ? "Cancelar novo objetivo"
              : "Novo Objetivo"
          }}
        </button>

        <form
          v-if="exibirFormularioNovoObjetivo"
          class="formulario"
          @submit.prevent="salvarObjetivoOkr"
        >
          <label>
            Objetivo estratégico
            <input
              v-model.trim="novoObjetivoOkr.texto"
              type="text"
              required
              placeholder="Descreva o objetivo estratégico"
            />
          </label>
          <label>
            Status
            <select v-model="novoObjetivoOkr.status">
              <option
                v-for="situacao in opcoesStatusOkr"
                :key="situacao"
                :value="situacao"
              >
                {{ situacao }}
              </option>
            </select>
          </label>
          <button
            type="submit"
            :disabled="processandoOkr || okrApiIndisponivel"
          >
            Adicionar objetivo
          </button>
        </form>
      </section>

      <section class="okr-lista">
        <h5>Objetivos estratégicos cadastrados</h5>
        <p v-if="!objetivosOkrSelecionados.length" class="okr-vazio">
          Nenhum objetivo cadastrado para esta área-chave.
        </p>

        <article
          v-for="objetivo in objetivosOkrSelecionados"
          :key="objetivo.idObjetivo"
          class="cartao-okr"
        >
          <details>
            <summary class="cartao-okr__cabecalho">
              <strong>{{ objetivo.texto }}</strong>
              <small
                >Status: {{ objetivo.status || "—" }} · Progresso:
                {{ formatarPercentual(objetivo.progresso) }}</small
              >
            </summary>

            <ul>
              <li
                v-for="resultado in objetivo.resultados || []"
                :key="resultado.idResultado"
              >
                <button
                  type="button"
                  class="kr-item"
                  @click="selecionarKrParaMensuracao(objetivo, resultado)"
                >
                  <span>{{ resultado.texto }}</span>
                  <span
                    >{{ resultado.percentualAtingido || 0 }}% ({{
                      resultado.status || "—"
                    }})</span
                  >
                </button>
              </li>
            </ul>
          </details>
        </article>
      </section>

      <section class="okr-cadastro-card">
        <button
          type="button"
          class="botao-acao"
          :disabled="
            processandoOkr ||
            okrApiIndisponivel ||
            !objetivosOkrSelecionados.length
          "
          @click="alternarFormularioKr"
        >
          {{ exibirFormularioNovoKr ? "Cancelar novo KR" : "Novo KR" }}
        </button>

        <form
          v-if="exibirFormularioNovoKr"
          class="formulario"
          @submit.prevent="salvarResultadoOkr"
        >
          <h5>Cadastrar resultado-chave (KR)</h5>
          <label>
            Objetivo estratégico
            <select v-model.number="novoResultadoOkr.idObjetivo" required>
              <option :value="null" disabled>Selecione um objetivo</option>
              <option
                v-for="objetivo in objetivosOkrSelecionados"
                :key="`objetivo-kr-${objetivo.idObjetivo}`"
                :value="objetivo.idObjetivo"
              >
                {{ objetivo.texto }}
              </option>
            </select>
          </label>
          <label>
            Resultado-chave
            <input
              v-model.trim="novoResultadoOkr.texto"
              type="text"
              required
              placeholder="Descreva o resultado-chave"
            />
          </label>
          <div class="duas-colunas">
            <label>
              Status
              <select v-model="novoResultadoOkr.status">
                <option
                  v-for="situacao in opcoesStatusOkr"
                  :key="situacao"
                  :value="situacao"
                >
                  {{ situacao }}
                </option>
              </select>
            </label>
            <label>
              % atingido
              <input
                v-model.number="novoResultadoOkr.percentualAtingido"
                type="number"
                min="0"
                max="100"
              />
            </label>
          </div>
          <button
            type="submit"
            :disabled="
              processandoOkr ||
              okrApiIndisponivel ||
              !objetivosOkrSelecionados.length
            "
          >
            Adicionar KR
          </button>
        </form>
      </section>

      <form
        v-if="edicaoKr.idResultado"
        class="formulario"
        @submit.prevent="salvarMensuracaoKrSelecionado"
      >
        <h5>Mensurar KR selecionado</h5>
        <p class="okr-painel__ajuda">
          KR: <strong>{{ edicaoKr.texto }}</strong>
        </p>
        <div class="duas-colunas">
          <label>
            Status
            <select v-model="edicaoKr.status">
              <option
                v-for="situacao in opcoesStatusOkr"
                :key="`edicao-${situacao}`"
                :value="situacao"
              >
                {{ situacao }}
              </option>
            </select>
          </label>
          <label>
            % atingido
            <input
              v-model.number="edicaoKr.percentualAtingido"
              type="number"
              min="0"
              max="100"
            />
          </label>
        </div>
        <div class="grupo-botoes-inline">
          <button
            type="button"
            class="botao-texto"
            @click="limparKrSelecionado"
          >
            Cancelar
          </button>
          <button
            type="submit"
            :disabled="processandoOkr || okrApiIndisponivel"
          >
            Salvar mensuração deste KR
          </button>
        </div>
      </form>
    </section>

    <section v-if="!eixoSelecionado" class="placeholder">
      <p>Selecione uma área chave para editar suas informações.</p>
    </section>

    <!-- Seção de detalhes removida - agora integrada na listagem -->

    <!-- <div v-else class="placeholder grande">
      <p>Selecione um município ou visualize todos os PDMs.</p>
    </div> -->

    <div
      v-if="modalEdicaoAberta"
      class="modal-overlay"
      @click.self="fecharAcaoPdm"
    >
      <form
        class="modal-caixa modal-edicao"
        @submit.prevent="atualizarPdmSelecionado"
        @blur.capture="agendarAutosavePdmSelecionado"
        @change.capture="agendarAutosavePdmSelecionado"
      >
        <div class="modal-header">
          <div class="modal-header-content">
            <div class="modal-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="modal-title-group">
              <h3>Editar plano municipal</h3>
              <p class="modal-descricao">
                Atualize as informações do plano de desenvolvimento municipal
              </p>
            </div>
          </div>
          <button type="button" class="modal-close-btn" @click="fecharAcaoPdm">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-field">
            <label class="form-label">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <polyline
                  points="14,2 14,8 20,8"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Nome do plano
            </label>
            <input
              v-model="formEdicaoPdm.nome"
              type="text"
              required
              placeholder="Ex: PDM 2025-2028"
              class="form-input"
            />
          </div>

          <div class="form-field">
            <label class="form-label">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 12l2 2 4-4"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Status do plano
            </label>
            <select v-model="formEdicaoPdm.status" required class="form-input">
              <option
                v-for="status in opcoesStatusPdm"
                :key="status"
                :value="status"
              >
                {{ status }}
              </option>
            </select>
          </div>

          <div class="form-section">
            <h4 class="section-title">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="3"
                  y="4"
                  width="18"
                  height="18"
                  rx="2"
                  ry="2"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <line
                  x1="16"
                  y1="2"
                  x2="16"
                  y2="6"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <line
                  x1="8"
                  y1="2"
                  x2="8"
                  y2="6"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
              Período de vigência
            </h4>
            <div class="date-fields">
              <div class="form-field">
                <label class="form-label">Data de início</label>
                <input
                  v-model="formEdicaoPdm.periodoInicio"
                  type="date"
                  required
                  :class="{
                    'form-input': true,
                    'input-error': erros.periodoEdicao,
                  }"
                  @input="limparErroPeriodo('edicao')"
                />
              </div>
              <div class="form-field">
                <label class="form-label">Data de fim</label>
                <input
                  v-model="formEdicaoPdm.periodoFim"
                  type="date"
                  required
                  :class="{
                    'form-input': true,
                    'input-error': erros.periodoEdicao,
                  }"
                  @input="limparErroPeriodo('edicao')"
                />
              </div>
            </div>
            <small v-if="erros.periodoEdicao" class="error-message">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <line
                  x1="12"
                  y1="8"
                  x2="12"
                  y2="12"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <line
                  x1="12"
                  y1="16"
                  x2="12.01"
                  y2="16"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
              A data de fim deve ser posterior à data de início
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="fecharAcaoPdm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Cancelar
          </button>
          <button type="submit" class="btn-primary" :disabled="processandoAcao">
            <svg
              v-if="!processandoAcao"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 6L9 17l-5-5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              v-else
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="spinner"
            >
              <path
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"
              />
            </svg>
            {{ processandoAcao ? "Salvando..." : "Salvar alterações" }}
          </button>
        </div>
      </form>
    </div>

    <div
      v-if="modalExclusaoAberta"
      class="modal-overlay"
      @click.self="fecharAcaoPdm"
    >
      <div class="modal-caixa modal-exclusao">
        <div class="modal-header">
          <div class="modal-header-content">
            <div class="modal-icon modal-icon-danger">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polyline
                  points="3,6 5,6 21,6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <line
                  x1="10"
                  y1="11"
                  x2="10"
                  y2="17"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <line
                  x1="14"
                  y1="11"
                  x2="14"
                  y2="17"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="modal-title-group">
              <h3>Excluir plano municipal</h3>
              <p class="modal-descricao">
                Esta ação é permanente e não pode ser desfeita
              </p>
            </div>
          </div>
          <button type="button" class="modal-close-btn" @click="fecharAcaoPdm">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <div class="warning-message">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <line
                x1="12"
                y1="9"
                x2="12"
                y2="13"
                stroke="currentColor"
                stroke-width="2"
              />
              <line
                x1="12"
                y1="17"
                x2="12.01"
                y2="17"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
            <div>
              <p>
                <strong
                  >Você está prestes a excluir este plano municipal</strong
                >
              </p>
              <p>
                Todas as áreas chave e vinculações serão removidas
                permanentemente.
              </p>
            </div>
          </div>

          <div v-if="!podeExcluirPdm" class="error-message-box">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="2"
              />
              <line
                x1="15"
                y1="9"
                x2="9"
                y2="15"
                stroke="currentColor"
                stroke-width="2"
              />
              <line
                x1="9"
                y1="9"
                x2="15"
                y2="15"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
            <div>
              <p><strong>Não é possível excluir este plano</strong></p>
              <p>
                Existem projetos vinculados às áreas chave deste PDM. Remova
                todos os vínculos antes de excluir.
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="fecharAcaoPdm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Cancelar
          </button>
          <button
            type="button"
            class="btn-danger"
            :disabled="!podeExcluirPdm || processandoAcao"
            @click="excluirPdmSelecionado"
          >
            <svg
              v-if="!processandoAcao"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polyline
                points="3,6 5,6 21,6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              v-else
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="spinner"
            >
              <path
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"
              />
            </svg>
            {{ processandoAcao ? "Excluindo..." : "Confirmar exclusão" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Edição de Área Chave -->
    <div
      v-if="modalEdicaoAreaAberta"
      class="modal-overlay"
      @click.self="fecharModalEdicaoArea"
    >
      <form
        class="modal-caixa modal-edicao"
        @submit.prevent="salvarEdicaoArea"
        @blur.capture="agendarAutosaveAreaSelecionada"
        @change.capture="agendarAutosaveAreaSelecionada"
      >
        <div class="modal-header">
          <div class="modal-header-content">
            <div class="modal-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="modal-title-group">
              <h3>Editar área chave</h3>
              <p class="modal-descricao">
                Atualize as informações da área chave da gestão municipal
              </p>
            </div>
          </div>
          <button
            type="button"
            class="modal-close-btn"
            @click="fecharModalEdicaoArea"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-field">
            <label class="form-label">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 11.08V12a10 10 0 1 1-5.93-9.14"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <polyline
                  points="22,4 12,14.01 9,11.01"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Área chave
            </label>
            <select v-model="formEdicaoEixo.nome" required class="form-select">
              <option value="">Selecione uma área...</option>
              <option
                v-for="nome in areasChaveParaEdicao"
                :key="nome"
                :value="nome"
              >
                {{ nome }}
              </option>
            </select>
          </div>

          <div class="form-field">
            <label class="form-label">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <polyline
                  points="14,2 14,8 20,8"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <line
                  x1="16"
                  y1="13"
                  x2="8"
                  y2="13"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <line
                  x1="16"
                  y1="17"
                  x2="8"
                  y2="17"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
              Descrição
            </label>
            <textarea
              v-model="formEdicaoEixo.descricao"
              rows="3"
              placeholder="Contextualize o foco desta área chave da gestão municipal..."
              class="form-textarea"
            ></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn-secondary"
            @click="fecharModalEdicaoArea"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Cancelar
          </button>
          <button type="submit" class="btn-primary" :disabled="processandoEixo">
            <svg
              v-if="!processandoEixo"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 6L9 17l-5-5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              v-else
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="spinner"
            >
              <path
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"
              />
            </svg>
            {{ processandoEixo ? "Salvando..." : "Salvar alterações" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComboboxMunicipio from "@/modules/city/components/ComboboxSingle.vue";
import { AREAS_CHAVE_GESTAO_MUNICIPAL } from "../constants/areasChave";
import Swal from "sweetalert2";
import {
  buscarProjetos,
  buscarPdms,
  buscarPdmDetalhe,
  criarPdmMunicipal,
  criarEixoPdm,
  atualizarEixoPdm,
  excluirEixoPdm,
  vincularProjetoAoEixo,
  atualizarPdmMunicipal,
  excluirPdmMunicipal,
  criarObjetivoOkr,
  atualizarObjetivoOkr,
  excluirObjetivoOkr,
  criarResultadoOkr,
  atualizarResultadoOkr,
  excluirResultadoOkr,
  obterMensuracaoOkr,
  registrarMensuracaoOkr,
} from "../services/api";

export default {
  name: "GestaoProjetosPdm",
  components: {
    ComboboxMunicipio,
  },
  data() {
    return {
      carregando: false,
      pdmCarregandoId: null,
      filtros: {
        idMunicipio: undefined,
        siglaEstado: "",
      },
      municipioFiltro: {
        municipio: null,
      },
      mostrarTodosMunicipios: false,
      exibirFormularioNovoPdm: false,
      pdms: [],
      detalhePdm: null,
      eixoSelecionado: null,
      eixoExpandidoId: null, // Para controlar qual área está expandida
      projetosDisponiveis: [],
      novoPdm: {
        nome: "",
        periodoInicio: "",
        periodoFim: "",
      },
      novoEixo: {
        nome: "",
        descricao: "",
      },
      formEdicaoEixo: {
        nome: "",
        descricao: "",
      },
      vinculoProjeto: {
        idProjeto: "",
        dataInicio: "",
        dataFim: "",
      },
      exibirFormularioEixo: false,
      exibindoEdicaoEixo: false,
      confirmandoExclusaoEixo: false,
      exibirFormularioProjeto: false,
      exibirFormularioNovoPdm: false,
      modalEdicaoAberta: false,
      modalExclusaoAberta: false,
      modalEdicaoAreaAberta: false,
      salvandoOkrs: false,
      autosavePdmTimeout: null,
      autosaveAreaTimeout: null,
      autosaveOkrsTimeout: null,
      autosavePdmExecutando: false,
      autosaveAreaExecutando: false,
      autosaveOkrsExecutando: false,
      okrStatusOpcoes: [
        "Ideacao",
        "Planejamento",
        "Execucao",
        "Monitoramento",
        "Concluido",
        "EmEspera",
        "Cancelado",
      ],
      mensuracaoAbertaId: null,
      mensuracaoRascunho: {},
      okrsEixosPendentes: [],
      okrsObjetivosRemovidos: [],
      okrsResultadosRemovidos: [],
      formEdicaoPdm: {
        nome: "",
        periodoInicio: "",
        periodoFim: "",
        status: "Planejado",
      },
      opcoesStatusPdm: [
        "Planejado",
        "Em andamento",
        "Concluído",
        "Suspenso",
        "Cancelado",
      ],
      processandoAcao: false,
      processandoEixo: false,
      alerta: {
        tipo: "",
        mensagem: "",
      },
      eixoAcoesAtivasId: null,
      areasChave: AREAS_CHAVE_GESTAO_MUNICIPAL,
      exibirPainelOkr: false,
      exibirFormularioNovoObjetivo: false,
      exibirFormularioNovoKr: false,
      processandoOkr: false,
      novoObjetivoOkr: { texto: "", status: "Planejamento" },
      novoResultadoOkr: {
        idObjetivo: null,
        texto: "",
        status: "Planejamento",
        percentualAtingido: 0,
      },
      edicaoKr: {
        idObjetivo: null,
        idResultado: null,
        texto: "",
        status: "Planejamento",
        percentualAtingido: 0,
      },
      opcoesStatusOkr: [
        "Planejamento",
        "Execucao",
        "Monitoramento",
        "Concluido",
        "EmEspera",
        "Cancelado",
      ],
      mensuracaoOkr: null,
      okrApiIndisponivel: false,
      mensagemOkr: "",
      erros: {
        periodoNovoPdm: false,
        periodoEdicao: false,
        periodoVinculo: false,
      },
      areasTableHeaders: [
        {
          text: "Área Chave",
          value: "nome",
          align: "start",
          sortable: true,
          width: "20%",
        },
        {
          text: "Descrição",
          value: "descricao",
          align: "start",
          sortable: false,
          width: "40%",
        },
        {
          text: "Projetos",
          value: "projetos",
          align: "center",
          sortable: true,
          width: "15%",
        },
        {
          text: "Ações",
          value: "acoes",
          align: "center",
          sortable: false,
          width: "25%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["uf"]),
    eixosOrdenados() {
      if (!this.detalhePdm || !this.detalhePdm.eixos) return [];
      return [...this.detalhePdm.eixos].sort(
        (a, b) => (a.ordem || 0) - (b.ordem || 0)
      );
    },
    areasChaveDisponiveis() {
      const ocupadas = new Set(
        (this.detalhePdm?.eixos || [])
          .map((eixo) => this.normalizarAreaChave(eixo?.nome || eixo?.titulo))
          .filter((nome) => nome)
      );
      return this.areasChave.filter(
        (nome) => !ocupadas.has(this.normalizarAreaChave(nome))
      );
    },
    areasChaveParaEdicao() {
      return [...this.areasChave];
    },
    podeCriarNovaAreaChave() {
      return this.areasChaveDisponiveis.length > 0;
    },
    totalProjetos() {
      const totalLista = this.pdms.reduce(
        (acc, pdm) => acc + (pdm.totalProjetos || 0),
        0
      );
      if (totalLista) return totalLista;
      if (!this.detalhePdm || !this.detalhePdm.eixos) return 0;
      return this.detalhePdm.eixos.reduce(
        (acc, eixo) => acc + (eixo.projetos || []).length,
        0
      );
    },
    possuiProjetosVinculados() {
      if (!this.detalhePdm) return false;
      if (typeof this.detalhePdm.totalProjetos === "number") {
        return this.detalhePdm.totalProjetos > 0;
      }
      if (!this.detalhePdm.eixos) return false;
      return this.detalhePdm.eixos.some(
        (eixo) => (eixo.projetos || []).length > 0
      );
    },
    podeExcluirPdm() {
      return !this.possuiProjetosVinculados;
    },
    objetivosOkrSelecionados() {
      return this.eixoSelecionado?.objetivosOkr || [];
    },
  },
  watch: {
    "filtros.idMunicipio": {
      immediate: false,
      handler() {
        this.carregarContexto();
        this.$nextTick(() => this.tentarSincronizarMunicipio());
      },
    },
    mostrarTodosMunicipios() {
      this.carregarContexto();
    },
    "$route.fullPath": {
      immediate: true,
      handler() {
        this.ajustarAcaoRota();
      },
    },
    "novoPdm.periodoInicio": function () {
      this.limparErroPeriodo("novo", false);
    },
    "novoPdm.periodoFim": function () {
      this.limparErroPeriodo("novo", false);
    },
    "formEdicaoPdm.periodoInicio": function () {
      this.limparErroPeriodo("edicao", false);
    },
    "formEdicaoPdm.periodoFim": function () {
      this.limparErroPeriodo("edicao", false);
    },
    "vinculoProjeto.dataInicio": function () {
      this.limparErroPeriodo("vinculo", false);
    },
    "vinculoProjeto.dataFim": function () {
      this.limparErroPeriodo("vinculo", false);
    },
  },
  async created() {
    this.filtros.siglaEstado = this.uf || "";
    this.tentarSincronizarMunicipio();
  },
  mounted() {
    if (typeof ResizeObserver === "undefined") return;
    this.observadorLarguraDescricoesOkr = new ResizeObserver(([entrada]) => {
      const largura = entrada.contentRect.width;
      if (largura === this.larguraDescricoesOkr) return;
      this.larguraDescricoesOkr = largura;
      this.$nextTick(() => {
        [
          ...(this.$refs.descricoesObjetivosOkr || []),
          ...(this.$refs.descricoesResultadosOkr || []),
        ].forEach((campo) => campo.calculateInputHeight());
      });
    });
    this.observadorLarguraDescricoesOkr.observe(this.$el);
  },
  beforeDestroy() {
    this.observadorLarguraDescricoesOkr?.disconnect();
    clearTimeout(this.autosavePdmTimeout);
    clearTimeout(this.autosaveAreaTimeout);
    clearTimeout(this.autosaveOkrsTimeout);
  },
  methods: {
    deveAutosalvarCampo(evento) {
      const alvo = evento?.target;
      if (!alvo || !alvo.matches || alvo.disabled || alvo.readOnly) {
        return false;
      }

      return alvo.matches("input, select, textarea");
    },
    agendarAutosavePdmSelecionado(evento) {
      if (
        !this.modalEdicaoAberta ||
        this.processandoAcao ||
        this.autosavePdmExecutando ||
        !this.deveAutosalvarCampo(evento)
      ) {
        return;
      }

      clearTimeout(this.autosavePdmTimeout);
      this.autosavePdmTimeout = setTimeout(() => {
        this.executarAutosavePdmSelecionado();
      }, 700);
    },
    async executarAutosavePdmSelecionado() {
      if (
        !this.modalEdicaoAberta ||
        this.processandoAcao ||
        this.autosavePdmExecutando
      ) {
        return;
      }

      this.autosavePdmExecutando = true;
      try {
        await this.atualizarPdmSelecionado({
          silencioso: true,
          fecharModal: false,
        });
      } finally {
        this.autosavePdmExecutando = false;
      }
    },
    agendarAutosaveAreaSelecionada(evento) {
      if (
        !this.modalEdicaoAreaAberta ||
        this.processandoEixo ||
        this.autosaveAreaExecutando ||
        !this.deveAutosalvarCampo(evento)
      ) {
        return;
      }

      clearTimeout(this.autosaveAreaTimeout);
      this.autosaveAreaTimeout = setTimeout(() => {
        this.executarAutosaveAreaSelecionada();
      }, 700);
    },
    async executarAutosaveAreaSelecionada() {
      if (
        !this.modalEdicaoAreaAberta ||
        this.processandoEixo ||
        this.autosaveAreaExecutando
      ) {
        return;
      }

      this.autosaveAreaExecutando = true;
      try {
        await this.salvarEdicaoArea({
          silencioso: true,
          fecharModal: false,
        });
      } finally {
        this.autosaveAreaExecutando = false;
      }
    },
    agendarAutosaveOkrsEixo(idEixo, evento) {
      if (evento?.target?.closest?.(".okr-mensuracao-form")) {
        return;
      }

      if (
        this.salvandoOkrs ||
        this.processandoOkr ||
        this.autosaveOkrsExecutando ||
        !this.detalhePdm ||
        !this.eixoSelecionado ||
        !this.deveAutosalvarCampo(evento)
      ) {
        return;
      }

      if (idEixo) {
        this.marcarOkrsPendentes(idEixo);
      }

      clearTimeout(this.autosaveOkrsTimeout);
      this.autosaveOkrsTimeout = setTimeout(() => {
        this.executarAutosaveOkrsEixo();
      }, 900);
    },
    async executarAutosaveOkrsEixo() {
      if (
        this.salvandoOkrs ||
        this.processandoOkr ||
        this.autosaveOkrsExecutando ||
        !this.okrsEixosPendentes.length
      ) {
        return;
      }

      this.autosaveOkrsExecutando = true;
      try {
        await this.salvarOkrsEixo({ silencioso: true });
      } finally {
        this.autosaveOkrsExecutando = false;
      }
    },
    abrirPainelOkrDoEixo(eixo) {
      if (!eixo) return;
      this.selecionarEixo(eixo);
      this.exibirPainelOkr = true;
      this.exibirFormularioNovoObjetivo = false;
      this.exibirFormularioNovoKr = false;
      this.mensagemOkr = "";
      this.carregarMensuracaoOkr();
    },
    alternarFormularioObjetivo() {
      this.exibirFormularioNovoObjetivo = !this.exibirFormularioNovoObjetivo;
      if (this.exibirFormularioNovoObjetivo) {
        this.exibirFormularioNovoKr = false;
      }
    },
    alternarFormularioKr() {
      if (!this.objetivosOkrSelecionados.length) return;
      this.exibirFormularioNovoKr = !this.exibirFormularioNovoKr;
      if (this.exibirFormularioNovoKr) {
        this.exibirFormularioNovoObjetivo = false;
      }
    },
    obterMensagemErroOkr(error, mensagemPadrao) {
      const status = error?.response?.status;
      const detalhe =
        error?.response?.data?.mensagem || error?.response?.data || "";
      if (status === 404) {
        return "A API de OKRs não está disponível neste backend (404). Publique a versão mais recente da API de Gestão de Projetos.";
      }
      if (detalhe && typeof detalhe === "string") {
        return detalhe;
      }
      return mensagemPadrao;
    },
    tratarErroOkr(error, mensagemPadrao) {
      const status = error?.response?.status;
      const mensagem = this.obterMensagemErroOkr(error, mensagemPadrao);
      this.mensagemOkr = mensagem;
      if (status === 404) {
        this.okrApiIndisponivel = true;
      }
      this.exibirErro(mensagem);
    },
    async recarregarDetalhePdmPreservandoEixo() {
      const idPdm = this.obterIdPdm(this.detalhePdm);
      const idEixoSelecionado = this.obterIdEixo(this.eixoSelecionado);
      await this.carregarDetalhePdm(idPdm, idEixoSelecionado);
      this.sincronizarObjetivoSelecionadoKr();
    },
    async carregarMensuracaoOkr() {
      if (!this.detalhePdm || !this.eixoSelecionado) return;
      try {
        const { data } = await obterMensuracaoOkr(
          this.obterIdPdm(this.detalhePdm),
          [this.obterIdEixo(this.eixoSelecionado)]
        );
        this.mensuracaoOkr = data;
      } catch (e) {
        this.tratarErroOkr(e, "Não foi possível carregar os OKRs.");
      }
    },
    async salvarObjetivoOkr() {
      if (
        !this.novoObjetivoOkr.texto ||
        !this.detalhePdm ||
        !this.eixoSelecionado ||
        this.okrApiIndisponivel
      )
        return;
      this.processandoOkr = true;
      try {
        await criarObjetivoOkr(
          this.obterIdPdm(this.detalhePdm),
          this.obterIdEixo(this.eixoSelecionado),
          this.novoObjetivoOkr
        );
        this.novoObjetivoOkr = { texto: "", status: "Planejamento" };
        this.mensagemOkr = "Objetivo cadastrado com sucesso.";
        this.exibirFormularioNovoObjetivo = false;
        await this.recarregarDetalhePdmPreservandoEixo();
        this.sincronizarObjetivoSelecionadoKr();
      } catch (e) {
        this.tratarErroOkr(e, "Não foi possível salvar o objetivo OKR.");
      } finally {
        this.processandoOkr = false;
      }
    },
    async salvarResultadoOkr(objetivo) {
      const idObjetivo =
        objetivo?.idObjetivo || this.novoResultadoOkr.idObjetivo;
      if (
        !idObjetivo ||
        !this.novoResultadoOkr.texto ||
        !this.detalhePdm ||
        !this.eixoSelecionado ||
        this.okrApiIndisponivel
      )
        return;
      this.processandoOkr = true;
      try {
        await criarResultadoOkr(
          this.obterIdPdm(this.detalhePdm),
          this.obterIdEixo(this.eixoSelecionado),
          idObjetivo,
          this.novoResultadoOkr
        );
        this.novoResultadoOkr = {
          idObjetivo: null,
          texto: "",
          status: "Planejamento",
          percentualAtingido: 0,
        };
        this.mensagemOkr = "Resultado-chave cadastrado com sucesso.";
        this.exibirFormularioNovoKr = false;
        await this.recarregarDetalhePdmPreservandoEixo();
      } catch (e) {
        this.tratarErroOkr(e, "Não foi possível salvar o resultado-chave.");
      } finally {
        this.processandoOkr = false;
      }
    },
    async salvarMensuracaoOkrPainel() {
      if (!this.detalhePdm || !this.eixoSelecionado || this.okrApiIndisponivel)
        return;
      const itens = (this.objetivosOkrSelecionados || []).flatMap((o) =>
        (o.resultados || []).map((r) => ({
          idResultado: r.idResultado,
          status: r.status,
          percentualAtingido: Number(r.percentualAtingido || 0),
        }))
      );
      if (!itens.length) {
        this.mensagemOkr =
          "Cadastre ao menos um resultado-chave para salvar a mensuração.";
        return;
      }
      this.processandoOkr = true;
      try {
        await registrarMensuracaoOkr(this.obterIdPdm(this.detalhePdm), {
          dataReferencia: new Date().toISOString().slice(0, 10),
          itens,
        });
        this.mensagemOkr = "Mensuração de OKRs registrada com sucesso.";
        this.exibirSucesso("Mensuração de OKRs registrada com sucesso.");
        await this.recarregarDetalhePdmPreservandoEixo();
      } catch (e) {
        this.tratarErroOkr(
          e,
          "Não foi possível registrar a mensuração de OKRs."
        );
      } finally {
        this.processandoOkr = false;
      }
    },
    selecionarKrParaMensuracao(objetivo, resultado) {
      if (!objetivo || !resultado) return;
      this.edicaoKr = {
        idObjetivo: objetivo.idObjetivo,
        idResultado: resultado.idResultado,
        texto: resultado.texto || "",
        status: resultado.status || "Planejamento",
        percentualAtingido: Number(resultado.percentualAtingido || 0),
      };
    },
    limparKrSelecionado() {
      this.edicaoKr = {
        idObjetivo: null,
        idResultado: null,
        texto: "",
        status: "Planejamento",
        percentualAtingido: 0,
      };
    },
    async salvarMensuracaoKrSelecionado() {
      if (
        !this.edicaoKr.idResultado ||
        !this.detalhePdm ||
        this.okrApiIndisponivel
      )
        return;
      this.processandoOkr = true;
      try {
        await registrarMensuracaoOkr(this.obterIdPdm(this.detalhePdm), {
          dataReferencia: new Date().toISOString().slice(0, 10),
          itens: [
            {
              idResultado: this.edicaoKr.idResultado,
              status: this.edicaoKr.status,
              percentualAtingido: Number(this.edicaoKr.percentualAtingido || 0),
            },
          ],
        });
        this.mensagemOkr = "Mensuração do KR registrada com sucesso.";
        this.exibirSucesso("Mensuração do KR registrada com sucesso.");
        await this.recarregarDetalhePdmPreservandoEixo();
        this.limparKrSelecionado();
      } catch (e) {
        this.tratarErroOkr(e, "Não foi possível salvar a mensuração deste KR.");
      } finally {
        this.processandoOkr = false;
      }
    },

    obterIdPdm(pdm) {
      return pdm?.id || pdm?.idPdm || pdm?.municipalDevelopmentPlanId;
    },
    obterIdEixo(eixo) {
      return eixo?.id || eixo?.idEixo || eixo?.projectStrategicAxisId;
    },
    obterChaveOkr(okr) {
      return okr?.id || okr?.idObjetivo || okr?.clientId;
    },
    obterIdResultadoOkr(resultado) {
      return resultado?.idResultado || resultado?.id || null;
    },
    alternarFormularioNovoEixo() {
      if (!this.podeCriarNovaAreaChave) {
        this.exibirErro("Todas as áreas chave já foram cadastradas neste PDM.");
        return;
      }
      if (this.exibirFormularioEixo) {
        this.exibirFormularioEixo = false;
        this.novoEixo = { nome: "", descricao: "" };
        return;
      }
      this.exibindoEdicaoEixo = false;
      this.confirmandoExclusaoEixo = false;
      this.exibirFormularioEixo = true;
      this.novoEixo = { nome: "", descricao: "" };
    },
    iniciarEdicaoEixo(eixo = null) {
      const eixoParaEditar = eixo || this.eixoSelecionado;
      if (!eixoParaEditar) return;

      this.eixoSelecionado = eixoParaEditar;
      this.formEdicaoEixo = {
        nome: eixoParaEditar?.nome || eixoParaEditar?.titulo || "",
        descricao: eixoParaEditar?.descricao || "",
      };
      this.modalEdicaoAreaAberta = true;
    },
    cancelarEdicaoEixo() {
      this.exibindoEdicaoEixo = false;
      this.formEdicaoEixo = { nome: "", descricao: "" };
    },
    // Novos métodos para acordeão de OKRs
    toggleOkrsEixo(eixo) {
      const eixoId = this.obterIdEixo(eixo);
      if (this.eixoExpandidoId === eixoId) {
        this.eixoExpandidoId = null;
        this.eixoSelecionado = null;
      } else {
        this.eixoExpandidoId = eixoId;
        this.eixoSelecionado = eixo;
        this.garantirOkrsEixo(eixo);
      }
    },
    obterOkrsEixo(eixo) {
      if (
        !eixo ||
        String(this.obterIdEixo(this.eixoSelecionado)) !==
          String(this.obterIdEixo(eixo))
      ) {
        return [];
      }
      this.garantirOkrsEixo(eixo);
      return eixo.okrs || [];
    },
    adicionarObjetivoOkrParaEixo(eixo) {
      this.eixoSelecionado = eixo;
      this.eixoExpandidoId = this.obterIdEixo(eixo);
      this.garantirOkrsEixo(eixo);
      this.adicionarObjetivoOkr();
    },
    async abrirConfirmacaoExcluirEixo(eixo = null) {
      const eixoParaExcluir = eixo || this.eixoSelecionado;
      if (!eixoParaExcluir) return;

      const nomeArea =
        eixoParaExcluir.nome || eixoParaExcluir.titulo || "esta área chave";
      const temProjetos = (eixoParaExcluir.projetos || []).length > 0;

      let texto = `Tem certeza que deseja excluir a área chave "${nomeArea}"?`;
      if (temProjetos) {
        texto +=
          "\n\nEsta área possui projetos vinculados que serão desvinculados.";
      }
      texto += "\n\nEsta ação não pode ser desfeita.";

      const resultado = await Swal.fire({
        title: "Excluir área chave?",
        text: texto,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        focusCancel: true,
      });

      if (resultado.isConfirmed) {
        this.eixoSelecionado = eixoParaExcluir;
        await this.excluirEixoSelecionado();
      }
    },
    cancelarExclusaoEixo() {
      this.confirmandoExclusaoEixo = false;
    },
    fecharModalEdicaoArea() {
      this.modalEdicaoAreaAberta = false;
      this.formEdicaoEixo = { nome: "", descricao: "" };
      this.eixoSelecionado = null;
    },
    async salvarEdicaoArea(opcoes = {}) {
      const { silencioso = false, fecharModal = true } = opcoes || {};
      if (!this.detalhePdm || !this.eixoSelecionado) {
        if (!silencioso) {
          this.alerta = {
            tipo: "erro",
            mensagem: "Erro: área chave não selecionada.",
          };
        }
        return;
      }

      const idPdm = this.obterIdPdm(this.detalhePdm);
      const idEixo = this.obterIdEixo(this.eixoSelecionado);

      if (!idPdm || !idEixo) {
        if (!silencioso) {
          this.alerta = {
            tipo: "erro",
            mensagem: "Erro: IDs inválidos para atualização.",
          };
        }
        return;
      }

      try {
        this.processandoEixo = true;
        const payload = { ...this.formEdicaoEixo };
        await atualizarEixoPdm(idPdm, idEixo, payload);

        // Recarregar os detalhes do PDM para garantir dados atualizados
        await this.carregarDetalhePdm(idPdm);

        if (fecharModal) {
          this.fecharModalEdicaoArea();
        }
        if (!silencioso) {
          this.alerta = {
            tipo: "sucesso",
            mensagem: "Área chave atualizada com sucesso!",
          };
        }
      } catch (error) {
        if (!silencioso) {
          console.error("Erro ao atualizar área chave:", error);
          this.alerta = {
            tipo: "erro",
            mensagem:
              "Erro ao atualizar área chave: " +
              (error.response?.data?.message || error.message || error),
          };
        }
      } finally {
        this.processandoEixo = false;
      }
    },
    aoAlterarMunicipio(municipio) {
      this.mostrarTodosMunicipios = false;
      if (Array.isArray(municipio)) {
        const selecionado = municipio.find(
          (item) => item && (item.municipioId || item.id)
        );
        this.filtros.idMunicipio = selecionado
          ? Number(selecionado.municipioId || selecionado.id)
          : undefined;
      } else if (municipio && typeof municipio === "object") {
        this.filtros.idMunicipio =
          municipio.municipioId || municipio.id || undefined;
      } else {
        this.filtros.idMunicipio = municipio || undefined;
      }
      this.municipioFiltro.municipio =
        municipio && typeof municipio === "object" ? municipio : null;
    },
    limparFiltros() {
      this.municipioFiltro.municipio = null;
      this.filtros.idMunicipio = undefined;
      this.mostrarTodosMunicipios = false;
      if (this.$refs.filtroMunicipio) {
        this.$refs.filtroMunicipio.clearSelection();
      }
    },
    abrirFormularioNovoPdm() {
      this.exibirFormularioNovoPdm = true;
    },
    fecharFormularioNovoPdm() {
      this.exibirFormularioNovoPdm = false;
      this.novoPdm = {
        nome: "",
        periodoInicio: "",
        periodoFim: "",
      };
      this.limparErroPeriodo("novo");
    },
    tentarSincronizarMunicipio(tentativa = 0) {
      if (this.mostrarTodosMunicipios) {
        this.municipioFiltro.municipio = null;
        return;
      }
      if (tentativa > 10) return;
      if (!this.filtros.idMunicipio) {
        this.municipioFiltro.municipio = null;
        return;
      }
      const combobox = this.$refs.filtroMunicipio;
      const lista = combobox?.municipios;
      if (Array.isArray(lista) && lista.length) {
        const encontrado = lista.find(
          (item) => item.municipioId === this.filtros.idMunicipio
        );
        if (encontrado) {
          this.municipioFiltro.municipio = encontrado;
          return;
        }
      }
      setTimeout(() => this.tentarSincronizarMunicipio(tentativa + 1), 200);
    },
    async carregarContexto() {
      if (!this.filtros.idMunicipio && !this.mostrarTodosMunicipios) {
        this.pdms = [];
        this.detalhePdm = null;
        this.eixoSelecionado = null;
        return;
      }
      await this.carregarPdms();
      if (this.filtros.idMunicipio && !this.mostrarTodosMunicipios) {
        await this.carregarProjetosDisponiveis();
      } else {
        this.projetosDisponiveis = [];
      }
    },
    async ajustarAcaoRota() {
      const nomeRota = this.$route?.name;
      if (!nomeRota || !nomeRota.startsWith("gestao-projetos.pdm")) {
        this.modalEdicaoAberta = false;
        this.modalExclusaoAberta = false;
        return;
      }
      if (nomeRota === "gestao-projetos.pdm") {
        this.modalEdicaoAberta = false;
        this.modalExclusaoAberta = false;
        return;
      }

      const idPdmRota = Number(this.$route.params?.idPdm);
      if (!idPdmRota) return;

      const selecionadoAtual =
        this.detalhePdm && this.obterIdPdm(this.detalhePdm);
      if (selecionadoAtual !== idPdmRota) {
        const existente = this.pdms.find(
          (pdm) => this.obterIdPdm(pdm) === idPdmRota
        );
        if (existente) {
          await this.selecionarPdm(existente);
        } else {
          await this.carregarDetalhePdm(idPdmRota);
        }
      }

      if (nomeRota === "gestao-projetos.pdm.editar") {
        const statusAtual = this.detalhePdm?.status || "Planejado";
        const opcoesStatus = this.opcoesStatusPdm.includes(statusAtual)
          ? this.opcoesStatusPdm
          : [statusAtual, ...this.opcoesStatusPdm];
        this.opcoesStatusPdm = [...new Set(opcoesStatus)];
        this.formEdicaoPdm = {
          nome: this.detalhePdm?.nome || this.detalhePdm?.titulo || "",
          periodoInicio: this.formatarDataInput(this.detalhePdm?.periodoInicio),
          periodoFim: this.formatarDataInput(this.detalhePdm?.periodoFim),
          status: statusAtual,
        };
        this.modalEdicaoAberta = true;
        this.modalExclusaoAberta = false;
      } else if (nomeRota === "gestao-projetos.pdm.excluir") {
        this.modalEdicaoAberta = false;
        this.modalExclusaoAberta = true;
      }
    },
    async carregarPdms() {
      try {
        this.carregando = true;
        const filtros = {
          siglaEstado: this.filtros.siglaEstado || undefined,
        };
        if (this.filtros.idMunicipio && !this.mostrarTodosMunicipios) {
          filtros.idMunicipio = this.filtros.idMunicipio;
        }
        const { data } = await buscarPdms(filtros);
        this.pdms = data || [];
        const primeiro = this.pdms[0];
        if (primeiro) {
          await this.selecionarPdm(primeiro);
        } else {
          this.detalhePdm = null;
          this.eixoSelecionado = null;
        }
      } catch (error) {
        this.exibirErro("Não foi possível carregar os PDMs do município.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] carregar pdms", error);
      } finally {
        this.carregando = false;
      }
    },
    async carregarProjetosDisponiveis() {
      if (!this.filtros.idMunicipio) {
        this.projetosDisponiveis = [];
        return;
      }
      try {
        const { data } = await buscarProjetos({
          idMunicipio: this.filtros.idMunicipio,
        });
        this.projetosDisponiveis = data || [];
      } catch (error) {
        this.projetosDisponiveis = [];
        this.exibirErro("Falha ao carregar os projetos do município.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] projetos municipio", error);
      }
    },
    async selecionarPdm(pdm) {
      console.log("aqui");
      if (!pdm) {
        this.detalhePdm = null;
        this.eixoSelecionado = null;
        this.eixoAcoesAtivasId = null;
        this.exibirFormularioEixo = false;
        this.exibindoEdicaoEixo = false;
        this.confirmandoExclusaoEixo = false;
        this.exibirFormularioProjeto = false;
        return;
      }

      // Se estamos clicando no mesmo PDM que já está aberto, feche-o
      if (
        this.detalhePdm &&
        this.obterIdPdm(pdm) === this.obterIdPdm(this.detalhePdm)
      ) {
        this.detalhePdm = null;
        this.eixoSelecionado = null;
        this.eixoAcoesAtivasId = null;
        this.exibirFormularioEixo = false;
        this.exibindoEdicaoEixo = false;
        this.confirmandoExclusaoEixo = false;
        this.exibirFormularioProjeto = false;
        this.okrsEixosPendentes = [];
        this.okrsObjetivosRemovidos = [];
        this.okrsResultadosRemovidos = [];
        this.pdmCarregandoId = null;
        return;
      }

      // Reset apenas dos estados de formulário, mantém o PDM atual durante carregamento
      this.eixoSelecionado = null;
      this.eixoAcoesAtivasId = null;
      this.exibirFormularioEixo = false;
      this.exibindoEdicaoEixo = false;
      this.confirmandoExclusaoEixo = false;
      this.exibirFormularioProjeto = false;
      this.okrApiIndisponivel = false;
      this.mensagemOkr = "";
      this.okrsEixosPendentes = [];
      this.okrsObjetivosRemovidos = [];
      this.okrsResultadosRemovidos = [];
      if (!pdm) return;

      // Definir o ID do PDM que está sendo carregado para mostrar o loading
      this.pdmCarregandoId = this.obterIdPdm(pdm);

      await this.carregarDetalhePdm(this.obterIdPdm(pdm));
    },
    async carregarDetalhePdm(idPdm, idEixoPreferido = null) {
      if (!idPdm) return;
      try {
        this.carregando = true;
        this.exibirFormularioEixo = false;
        this.exibindoEdicaoEixo = false;
        this.confirmandoExclusaoEixo = false;
        const { data } = await buscarPdmDetalhe(idPdm);
        this.detalhePdm = data;
        const eixoPreferido = this.eixosOrdenados.find(
          (item) =>
            String(this.obterIdEixo(item)) === String(idEixoPreferido)
        );
        this.eixoSelecionado = eixoPreferido || this.eixosOrdenados[0] || null;
        this.eixoAcoesAtivasId = this.eixoSelecionado
          ? this.obterIdEixo(this.eixoSelecionado)
          : null;
        this.sincronizarObjetivoSelecionadoKr();
      } catch (error) {
        this.exibirErro("Não foi possível carregar os detalhes do PDM.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] detalhe pdm", error);
      } finally {
        this.carregando = false;
        this.pdmCarregandoId = null;
      }
    },
    async criarNovoPdm() {
      if (!this.filtros.idMunicipio) {
        this.exibirErro("Selecione um município para cadastrar o PDM.");
        return;
      }
      if (
        !this.validarPeriodo(
          this.novoPdm.periodoInicio,
          this.novoPdm.periodoFim,
          "novo"
        )
      ) {
        return;
      }
      try {
        this.carregando = true;
        const payload = {
          ...this.novoPdm,
          idMunicipio: this.filtros.idMunicipio,
        };
        const { data } = await criarPdmMunicipal(payload);
        this.pdms = [data, ...this.pdms];
        this.novoPdm = { nome: "", periodoInicio: "", periodoFim: "" };
        this.limparErroPeriodo("novo");
        await this.selecionarPdm(data);
        this.exibirSucesso("PDM cadastrado com sucesso!");
        this.fecharFormularioNovoPdm();
      } catch (error) {
        this.exibirErro("Não foi possível criar o PDM.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] criar pdm", error);
      } finally {
        this.carregando = false;
      }
    },
    async criarNovoEixo() {
      if (!this.detalhePdm) {
        this.exibirErro("Selecione um PDM antes de criar a área chave.");
        return;
      }
      if (!this.novoEixo.nome) {
        this.exibirErro("Selecione uma área chave para cadastrar.");
        return;
      }
      try {
        this.carregando = true;
        this.processandoEixo = true;
        const { data } = await criarEixoPdm(
          this.obterIdPdm(this.detalhePdm),
          this.novoEixo
        );
        this.detalhePdm.eixos = [...(this.detalhePdm.eixos || []), data];
        this.novoEixo = { nome: "", descricao: "" };
        this.exibirFormularioEixo = false;
        this.eixoSelecionado = data;
        this.eixoAcoesAtivasId = this.obterIdEixo(data);
        this.exibirSucesso("Área chave cadastrada com sucesso!");
      } catch (error) {
        this.exibirErro("Não foi possível cadastrar a área chave.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] criar eixo", error);
      } finally {
        this.carregando = false;
        this.processandoEixo = false;
      }
    },
    async atualizarEixoSelecionado() {
      if (!this.detalhePdm || !this.eixoSelecionado) {
        this.exibirErro("Selecione uma área chave para editar.");
        return;
      }
      const idPdm = this.obterIdPdm(this.detalhePdm);
      const idEixo = this.obterIdEixo(this.eixoSelecionado);
      if (!idPdm || !idEixo) return;
      try {
        this.processandoEixo = true;
        const payload = { ...this.formEdicaoEixo };
        const { data } = await atualizarEixoPdm(idPdm, idEixo, payload);
        const atualizado = data || { ...this.eixoSelecionado, ...payload };
        const indice = this.detalhePdm.eixos.findIndex(
          (eixo) => this.obterIdEixo(eixo) === idEixo
        );
        if (indice >= 0) {
          this.$set(this.detalhePdm.eixos, indice, atualizado);
        }
        this.eixoSelecionado = atualizado;
        this.eixoAcoesAtivasId = this.obterIdEixo(atualizado);
        this.exibindoEdicaoEixo = false;
        this.exibirSucesso("Área chave atualizada com sucesso!");
      } catch (error) {
        this.exibirErro("Não foi possível atualizar a área chave.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] atualizar eixo", error);
      } finally {
        this.processandoEixo = false;
      }
    },
    async excluirEixoSelecionado() {
      if (!this.detalhePdm || !this.eixoSelecionado) {
        this.exibirErro("Selecione uma área chave para excluir.");
        return;
      }
      const idPdm = this.obterIdPdm(this.detalhePdm);
      const idEixo = this.obterIdEixo(this.eixoSelecionado);
      if (!idPdm || !idEixo) return;

      const nomeArea =
        this.eixoSelecionado.nome ||
        this.eixoSelecionado.titulo ||
        "Área chave";

      // Mostrar loading durante a exclusão
      Swal.fire({
        title: "Excluindo área chave...",
        text: "Aguarde enquanto processamos a exclusão.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        this.processandoEixo = true;
        await excluirEixoPdm(idPdm, idEixo);

        // Atualizar a lista de eixos
        const restante = (this.detalhePdm.eixos || []).filter(
          (eixo) => this.obterIdEixo(eixo) !== idEixo
        );
        this.$set(this.detalhePdm, "eixos", restante);

        // Resetar estados
        this.confirmandoExclusaoEixo = false;
        this.eixoSelecionado = this.eixosOrdenados[0] || null;
        this.eixoAcoesAtivasId = null;

        if (!this.eixoSelecionado) {
          this.exibirFormularioProjeto = false;
        }

        // Fechar loading e mostrar sucesso
        Swal.fire({
          title: "Sucesso!",
          text: `A área chave "${nomeArea}" foi excluída com sucesso.`,
          icon: "success",
          confirmButtonText: "OK",
          timer: 3000,
          timerProgressBar: true,
        });
      } catch (error) {
        // Fechar loading e mostrar erro
        Swal.fire({
          title: "Erro",
          text: `Não foi possível excluir a área chave "${nomeArea}". Tente novamente.`,
          icon: "error",
          confirmButtonText: "OK",
        });

        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] excluir eixo", error);
      } finally {
        this.processandoEixo = false;
      }
    },
    async vincularProjeto() {
      if (!this.eixoSelecionado || !this.detalhePdm) {
        this.exibirErro("Selecione uma área chave para vincular o projeto.");
        return;
      }
      if (
        !this.validarPeriodo(
          this.vinculoProjeto.dataInicio,
          this.vinculoProjeto.dataFim,
          "vinculo"
        )
      ) {
        return;
      }
      try {
        this.carregando = true;
        const payload = {
          ...this.vinculoProjeto,
        };
        const { data } = await vincularProjetoAoEixo(
          this.obterIdPdm(this.detalhePdm),
          this.obterIdEixo(this.eixoSelecionado),
          payload
        );
        const indice = this.detalhePdm.eixos.findIndex(
          (eixo) =>
            this.obterIdEixo(eixo) === this.obterIdEixo(this.eixoSelecionado)
        );
        if (indice >= 0) {
          const projetos = [
            ...(this.detalhePdm.eixos[indice].projetos || []),
            data,
          ];
          this.$set(this.detalhePdm.eixos[indice], "projetos", projetos);
          this.eixoSelecionado = { ...this.detalhePdm.eixos[indice] };
        }
        this.vinculoProjeto = { idProjeto: "", dataInicio: "", dataFim: "" };
        this.exibirFormularioProjeto = false;
        this.exibirSucesso("Projeto vinculado com sucesso!");
      } catch (error) {
        this.exibirErro("Não foi possível vincular o projeto.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] vincular projeto", error);
      } finally {
        this.carregando = false;
      }
    },
    selecionarEixo(eixo) {
      this.eixoSelecionado = eixo;
      this.exibirFormularioProjeto = false;
      this.exibindoEdicaoEixo = false;
      this.confirmandoExclusaoEixo = false;
      this.eixoAcoesAtivasId = this.obterIdEixo(eixo);
      this.sincronizarObjetivoSelecionadoKr();
      this.limparKrSelecionado();
      this.exibirFormularioNovoObjetivo = false;
      this.exibirFormularioNovoKr = false;
    },
    sincronizarObjetivoSelecionadoKr() {
      const idsObjetivos = (this.objetivosOkrSelecionados || []).map(
        (item) => item.idObjetivo
      );
      if (!idsObjetivos.length) {
        this.novoResultadoOkr.idObjetivo = null;
      }
    },
    selecionarEixoParaOkrs(eixo) {
      this.eixoSelecionado = eixo;
      this.eixoAcoesAtivasId = this.obterIdEixo(eixo);
      this.exibirPainelOkr = true;
      this.mensuracaoAbertaId = null;
      this.mensuracaoRascunho = {};
      this.garantirOkrsEixo(eixo);
      this.carregarMensuracaoOkr();
      // Scroll suave até a seção de OKRs
      this.$nextTick(() => {
        const okrsSection =
          document.querySelector(".okr-painel") ||
          document.querySelector(".area-okrs-premium-section");
        if (okrsSection) {
          okrsSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    async carregarOpcoesOkrs() {
      try {
        const { data } = await buscarOpcoes({
          siglaEstado: this.filtros.siglaEstado || undefined,
        });
        if (data?.situacoes?.length) {
          this.okrStatusOpcoes = data.situacoes;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] opcoes okrs", error);
      }
    },
    garantirOkrsEixo(eixo) {
      if (!eixo) return;
      const idEixo = this.obterIdEixo(eixo);
      const objetivosApi = Array.isArray(eixo.objetivosOkr)
        ? eixo.objetivosOkr
        : [];
      const okrs = Array.isArray(eixo.okrs)
        ? eixo.okrs
        : objetivosApi.map((objetivo) => {
            const resultados = (objetivo.resultados || []).map((resultado) => {
              const historicoMensuracoes =
                this.normalizarHistoricoMensuracaoResultado(resultado);
              const ultimaMensuracao = historicoMensuracoes[0] || null;
              const statusAtual =
                ultimaMensuracao?.status ||
                resultado.status ||
                "Planejamento";
              const percentualAtual = this.normalizarPercentual(
                ultimaMensuracao?.percentual ??
                  resultado.percentualAtingido ??
                  resultado.percentual
              );
              return {
                id: resultado.idResultado,
                idResultado: resultado.idResultado,
                clientId: resultado.idResultado || this.gerarId(),
                referencia: resultado.idResultado || this.gerarId(),
                titulo: resultado.texto || resultado.titulo || "",
                status: statusAtual,
                statusOriginal: statusAtual,
                percentual: percentualAtual,
                percentualOriginal: percentualAtual,
                dataUltimaMensuracao:
                  resultado.dataUltimaMensuracao ||
                  resultado.dataUltimoRegistro ||
                  ultimaMensuracao?.data ||
                  null,
                historicoMensuracoes,
              };
            });

            return {
              id: objetivo.idObjetivo,
              idObjetivo: objetivo.idObjetivo,
              clientId: objetivo.idObjetivo || this.gerarId(),
              referencia: objetivo.idObjetivo || this.gerarId(),
              eixoId: idEixo,
              titulo: objetivo.texto || objetivo.titulo || "",
              status: objetivo.status || "Planejamento",
              progresso: this.normalizarPercentual(objetivo.progresso),
              mensuracoes: this.montarMensuracoesOkr(resultados),
              resultados,
            };
          });
      okrs.forEach((okr) => {
        if (!okr.clientId) okr.clientId = this.gerarId();
        if (!okr.referencia) okr.referencia = okr.clientId;
        if (!okr.eixoId) okr.eixoId = idEixo;
        if (!Array.isArray(okr.resultados)) {
          okr.resultados = [];
        }
        if (!Array.isArray(okr.mensuracoes)) {
          okr.mensuracoes = [];
        }
        okr.resultados.forEach((resultado) => {
          if (!resultado.clientId) resultado.clientId = this.gerarId();
          if (!resultado.referencia) resultado.referencia = resultado.clientId;
          resultado.percentual = this.normalizarPercentual(
            resultado.percentual
          );
          resultado.status = resultado.status || "Planejamento";
        });
        okr.status = okr.status || "Planejamento";
      });
      if (!Array.isArray(eixo.okrs)) {
        this.$set(eixo, "okrs", okrs);
      }
    },
    normalizarHistoricoMensuracaoResultado(resultado) {
      const historico = Array.isArray(resultado?.historicoMensuracoes)
        ? resultado.historicoMensuracoes
        : [];
      const registros = historico.length
        ? historico
        : resultado?.dataUltimaMensuracao
        ? [
            {
              dataReferencia: resultado.dataUltimaMensuracao,
              status: resultado.status,
              percentualAtingido: resultado.percentualAtingido,
            },
          ]
        : [];
      return registros
        .map((registro) => ({
          idMensuracao: registro.idMensuracao || registro.id || null,
          idMensuracaoResultado: registro.idMensuracaoResultado || null,
          data:
            registro.dataReferencia ||
            registro.data ||
            registro.dataRegistro ||
            resultado.dataUltimaMensuracao ||
            null,
          dataRegistro: registro.dataRegistro || null,
          status: registro.status || resultado.status || "Planejamento",
          percentual: this.normalizarPercentual(
            registro.percentualAtingido ??
              registro.percentual ??
              resultado.percentualAtingido ??
              resultado.percentual
          ),
        }))
        .filter((registro) => registro.data)
        .sort((a, b) => {
          const dataA = new Date(a.data).getTime() || 0;
          const dataB = new Date(b.data).getTime() || 0;
          if (dataA !== dataB) return dataB - dataA;
          return (
            Number(b.idMensuracaoResultado || b.idMensuracao || 0) -
            Number(a.idMensuracaoResultado || a.idMensuracao || 0)
          );
        });
    },
    montarMensuracoesOkr(resultados = []) {
      const mapa = new Map();
      resultados.forEach((resultado) => {
        const idResultado = this.obterIdResultadoOkr(resultado);
        (resultado.historicoMensuracoes || []).forEach((registro) => {
          const chave =
            registro.idMensuracao ||
            registro.data ||
            `${idResultado}-${registro.idMensuracaoResultado}`;
          if (!chave) return;
          if (!mapa.has(chave)) {
            mapa.set(chave, {
              id: registro.idMensuracao || null,
              data: registro.data,
              dataRegistro: registro.dataRegistro,
              resultados: [],
            });
          }
          mapa.get(chave).resultados.push({
            idResultado,
            referenciaResultado: resultado.referencia || resultado.clientId,
            titulo: resultado.titulo,
            percentual: registro.percentual,
            status: registro.status,
          });
        });
      });
      return [...mapa.values()].sort((a, b) => {
        const dataA = a?.data ? new Date(a.data).getTime() : 0;
        const dataB = b?.data ? new Date(b.data).getTime() : 0;
        if (dataA !== dataB) return dataB - dataA;
        return Number(b.id || 0) - Number(a.id || 0);
      });
    },
    gerarId() {
      return `${Date.now().toString(36)}${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    },
    normalizarPercentual(valor) {
      const numero = Number(valor);
      if (Number.isNaN(numero)) return 0;
      return Math.min(100, Math.max(0, numero));
    },
    adicionarObjetivoOkr() {
      if (!this.eixoSelecionado) return;
      this.garantirOkrsEixo(this.eixoSelecionado);
      const idEixo = this.obterIdEixo(this.eixoSelecionado);
      const clientId = this.gerarId();
      const resultadoId = this.gerarId();
      this.eixoSelecionado.okrs.push({
        clientId,
        referencia: clientId,
        eixoId: idEixo,
        titulo: "",
        status: "Planejamento",
        resultados: [
          {
            clientId: resultadoId,
            referencia: resultadoId,
            titulo: "",
            status: "Planejamento",
            percentual: 0,
          },
        ],
        mensuracoes: [],
      });
      this.marcarOkrsPendentes(idEixo);
    },
    obterIdObjetivoPersistido(okr) {
      const id = Number(okr?.idObjetivo || okr?.id || 0);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    obterIdResultadoPersistido(resultado) {
      const id = Number(resultado?.idResultado || resultado?.id || 0);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    async confirmarRemocaoOkr(titulo, texto) {
      const resultado = await Swal.fire({
        title: titulo,
        text: texto,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        focusCancel: true,
      });
      return resultado.isConfirmed;
    },
    registrarObjetivoRemovido(idEixo, idObjetivo) {
      if (!idEixo || !idObjetivo) return;
      const jaRegistrado = this.okrsObjetivosRemovidos.some(
        (item) =>
          String(item.idEixo) === String(idEixo) &&
          String(item.idObjetivo) === String(idObjetivo)
      );
      if (!jaRegistrado) {
        this.okrsObjetivosRemovidos.push({ idEixo, idObjetivo });
      }
    },
    registrarResultadoRemovido(idEixo, idObjetivo, idResultado) {
      if (!idEixo || !idObjetivo || !idResultado) return;
      const jaRegistrado = this.okrsResultadosRemovidos.some(
        (item) =>
          String(item.idEixo) === String(idEixo) &&
          String(item.idObjetivo) === String(idObjetivo) &&
          String(item.idResultado) === String(idResultado)
      );
      if (!jaRegistrado) {
        this.okrsResultadosRemovidos.push({
          idEixo,
          idObjetivo,
          idResultado,
        });
      }
    },
    async removerObjetivoOkr(indice) {
      if (!this.eixoSelecionado) return;
      const okr = this.eixoSelecionado.okrs?.[indice];
      if (!okr) return;

      const idEixo = this.obterIdEixo(this.eixoSelecionado);
      const idObjetivo = this.obterIdObjetivoPersistido(okr);
      if (idObjetivo) {
        const confirmado = await this.confirmarRemocaoOkr(
          "Excluir objetivo OKR?",
          "Esta acao remove o objetivo, seus KRs e as mensuracoes vinculadas imediatamente."
        );
        if (!confirmado) return;

        this.processandoOkr = true;
        try {
          await excluirObjetivoOkr(
            this.obterIdPdm(this.detalhePdm),
            idEixo,
            idObjetivo
          );
          this.okrsObjetivosRemovidos = this.okrsObjetivosRemovidos.filter(
            (item) => String(item.idObjetivo) !== String(idObjetivo)
          );
          this.okrsResultadosRemovidos = this.okrsResultadosRemovidos.filter(
            (item) => String(item.idObjetivo) !== String(idObjetivo)
          );
          this.exibirSucesso("Objetivo OKR excluido com sucesso.");
          await this.recarregarDetalhePdmPreservandoEixo();
        } catch (error) {
          this.tratarErroOkr(error, "Nao foi possivel excluir o objetivo OKR.");
        } finally {
          this.processandoOkr = false;
        }
        return;
      }

      this.marcarOkrsPendentes(idEixo);
      this.eixoSelecionado.okrs.splice(indice, 1);
      if (
        this.mensuracaoAbertaId &&
        !this.eixoSelecionado.okrs.find(
          (okr) => this.obterChaveOkr(okr) === this.mensuracaoAbertaId
        )
      ) {
        this.mensuracaoAbertaId = null;
        this.mensuracaoRascunho = {};
      }
    },
    adicionarResultadoOkr(okr) {
      if (!okr) return;
      this.marcarOkrsPendentes(okr.eixoId);
      const clientId = this.gerarId();
      okr.resultados.push({
        clientId,
        referencia: clientId,
        titulo: "",
        status: "Planejamento",
        percentual: 0,
      });
    },
    async removerResultadoOkr(okr, indice) {
      if (!okr || !Array.isArray(okr.resultados)) return;
      const resultado = okr.resultados[indice];
      if (!resultado) return;

      const idEixo = okr.eixoId || this.obterIdEixo(this.eixoSelecionado);
      const idObjetivo = this.obterIdObjetivoPersistido(okr);
      const idResultado = this.obterIdResultadoPersistido(resultado);
      if (idObjetivo && idResultado) {
        const confirmado = await this.confirmarRemocaoOkr(
          "Excluir KR?",
          "Esta acao remove o resultado-chave e suas mensuracoes imediatamente."
        );
        if (!confirmado) return;

        this.processandoOkr = true;
        try {
          await excluirResultadoOkr(
            this.obterIdPdm(this.detalhePdm),
            idEixo,
            idObjetivo,
            idResultado
          );
          this.okrsResultadosRemovidos = this.okrsResultadosRemovidos.filter(
            (item) => String(item.idResultado) !== String(idResultado)
          );
          this.exibirSucesso("Resultado-chave excluido com sucesso.");
          await this.recarregarDetalhePdmPreservandoEixo();
        } catch (error) {
          this.tratarErroOkr(error, "Nao foi possivel excluir o resultado-chave.");
        } finally {
          this.processandoOkr = false;
        }
        return;
      }

      this.marcarOkrsPendentes(idEixo);
      okr.resultados.splice(indice, 1);
    },
    obterChaveResultado(resultado) {
      return resultado?.id || resultado?.idResultado || resultado?.clientId;
    },
    marcarOkrsPendentes(idEixo) {
      if (!idEixo) return;
      if (!this.okrsEixosPendentes.includes(idEixo)) {
        this.okrsEixosPendentes.push(idEixo);
      }
    },
    alterarEixoObjetivo(okr) {
      if (!okr || !this.detalhePdm?.eixos?.length || !this.eixoSelecionado) {
        return;
      }
      const idAtual = this.obterIdEixo(this.eixoSelecionado);
      const novoId = okr.eixoId || idAtual;
      const eixoDestino = this.detalhePdm.eixos.find(
        (eixo) => String(this.obterIdEixo(eixo)) === String(novoId)
      );
      if (!eixoDestino) {
        okr.eixoId = idAtual;
        return;
      }
      okr.eixoId = this.obterIdEixo(eixoDestino);
      this.marcarOkrsPendentes(idAtual);
      this.marcarOkrsPendentes(okr.eixoId);
    },
    obterUltimaMensuracao(okr) {
      if (!okr?.mensuracoes?.length) return null;
      const ordenadas = [...okr.mensuracoes].sort((a, b) => {
        const dataA = a?.data ? new Date(a.data).getTime() : 0;
        const dataB = b?.data ? new Date(b.data).getTime() : 0;
        return dataB - dataA;
      });
      return ordenadas[0] || null;
    },
    obterDataUltimaMensuracao(okr) {
      const ultima = this.obterUltimaMensuracao(okr);
      if (!ultima?.data) return "Nenhuma mensuração registrada.";
      return new Date(ultima.data).toLocaleDateString("pt-BR");
    },
    obterHistoricoMensuracoesOkr(okr) {
      const linhas = [];
      (okr?.mensuracoes || []).forEach((mensuracao) => {
        (mensuracao.resultados || []).forEach((resultado) => {
          const idResultado = this.obterIdResultadoOkr(resultado);
          linhas.push({
            chave: `${mensuracao.id || mensuracao.data}-${idResultado}-${
              resultado.percentual
            }`,
            idMensuracao: mensuracao.id || null,
            data: mensuracao.data,
            idResultado,
            resultadoTitulo: resultado.titulo || "Resultado chave",
            percentual: this.normalizarPercentual(resultado.percentual),
            status: resultado.status,
            evolucao: null,
          });
        });
      });

      const porResultado = linhas.reduce((mapa, linha) => {
        const chave = linha.idResultado || linha.resultadoTitulo;
        if (!mapa.has(chave)) mapa.set(chave, []);
        mapa.get(chave).push(linha);
        return mapa;
      }, new Map());

      porResultado.forEach((itens) => {
        itens
          .sort((a, b) => {
            const dataA = a?.data ? new Date(a.data).getTime() : 0;
            const dataB = b?.data ? new Date(b.data).getTime() : 0;
            if (dataA !== dataB) return dataA - dataB;
            return Number(a.idMensuracao || 0) - Number(b.idMensuracao || 0);
          })
          .forEach((item, indice, ordenados) => {
            if (indice > 0) {
              item.evolucao =
                item.percentual -
                this.normalizarPercentual(ordenados[indice - 1].percentual);
            }
          });
      });

      return linhas.sort((a, b) => {
        const dataA = a?.data ? new Date(a.data).getTime() : 0;
        const dataB = b?.data ? new Date(b.data).getTime() : 0;
        if (dataA !== dataB) return dataB - dataA;
        return Number(b.idMensuracao || 0) - Number(a.idMensuracao || 0);
      });
    },
    formatarDataOkr(valor) {
      if (!valor) return "Sem data";
      return new Date(valor).toLocaleDateString("pt-BR");
    },
    formatarEvolucaoOkr(valor) {
      const numero = Number(valor);
      if (!Number.isFinite(numero) || numero === 0) return "sem variação";
      const sinal = numero > 0 ? "+" : "";
      return `${sinal}${numero.toFixed(0)} p.p.`;
    },
    abrirMensuracaoOkr(okr) {
      if (!okr) return;
      this.mensuracaoAbertaId = this.obterChaveOkr(okr);
      const ultima = this.obterUltimaMensuracao(okr);
      const rascunho = {};
      (okr.resultados || []).forEach((resultado) => {
        const idResultado = this.obterIdResultadoOkr(resultado);
        const valorUltimo = ultima?.resultados?.find(
          (item) => this.obterIdResultadoOkr(item) === idResultado
        );
        rascunho[this.obterChaveResultado(resultado)] =
          this.normalizarPercentual(
            valorUltimo?.percentual ?? resultado.percentual ?? 0
          );
      });
      this.mensuracaoRascunho = rascunho;
    },
    cancelarMensuracaoOkr() {
      this.mensuracaoAbertaId = null;
      this.mensuracaoRascunho = {};
    },
    async salvarMensuracaoOkr(okr = null) {
      if (!okr) return this.salvarMensuracaoOkrPainel();
      if (!this.detalhePdm || this.okrApiIndisponivel) return;
      const data = new Date().toISOString();
      const resultados = (okr.resultados || []).map((resultado) => {
        const idResultado = this.obterIdResultadoOkr(resultado);
        const percentual = this.normalizarPercentual(
          this.mensuracaoRascunho[this.obterChaveResultado(resultado)]
        );
        resultado.percentual = percentual;
        return {
          idResultado,
          referenciaResultado: resultado.referencia || resultado.clientId,
          percentual,
          status: resultado.status || okr.status || "Monitoramento",
        };
      });

      if (!resultados.length) {
        this.exibirErro("Inclua ao menos um resultado-chave antes de mensurar.");
        return;
      }

      if (resultados.some((item) => !item.idResultado)) {
        this.exibirErro(
          "Salve os OKRs antes de registrar a mensuracao dos resultados-chave."
        );
        return;
      }

      this.processandoOkr = true;
      try {
        await registrarMensuracaoOkr(this.obterIdPdm(this.detalhePdm), {
          dataReferencia: data.slice(0, 10),
          itens: resultados.map((item) => ({
            idResultado: item.idResultado,
            status: item.status,
            percentualAtingido: item.percentual,
          })),
        });
      } catch (error) {
        this.tratarErroOkr(
          error,
          "Nao foi possivel registrar a mensuracao de OKRs."
        );
        return;
      } finally {
        this.processandoOkr = false;
      }

      okr.mensuracoes = [
        ...(okr.mensuracoes || []),
        {
          data,
          resultados,
        },
      ];
      const concluidos = resultados.length
        ? resultados.every((item) => item.percentual >= 100)
        : false;
      if (concluidos) {
        okr.status = "Concluido";
      }
      this.exibirSucesso("Mensuracao de OKRs registrada com sucesso.");
      this.cancelarMensuracaoOkr();
      await this.recarregarDetalhePdmPreservandoEixo();
    },
    async salvarOkrsEixo(opcoes = {}) {
      if (!this.detalhePdm || !this.eixoSelecionado) return;
      const { silencioso = false } = opcoes || {};
      try {
        this.salvandoOkrs = true;
        const idPdm = this.obterIdPdm(this.detalhePdm);
        const idEixoSelecionado = this.obterIdEixo(this.eixoSelecionado);
        const eixosPendentes = this.okrsEixosPendentes.length
          ? [...new Set([...this.okrsEixosPendentes, idEixoSelecionado])]
          : [idEixoSelecionado];
        const okrsPorEixo = this.agruparOkrsPorEixo();
        for (const idEixo of eixosPendentes) {
          const eixoAtual = this.detalhePdm.eixos.find(
            (eixo) => String(this.obterIdEixo(eixo)) === String(idEixo)
          );
          if (!eixoAtual) continue;
          const okrsEixo = okrsPorEixo.get(idEixo) || [];
          // eslint-disable-next-line no-await-in-loop
          await this.salvarOkrsParaEixo(idPdm, eixoAtual, okrsEixo);
        }
        this.okrsEixosPendentes = [];
        if (!silencioso) {
          this.exibirSucesso("OKRs salvos com sucesso!");
        }
      } catch (error) {
        if (!silencioso) {
          this.exibirErro(error?.message || "Nao foi possivel salvar os OKRs.");
        }
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] salvar okrs", error);
      } finally {
        this.salvandoOkrs = false;
      }
    },
    agruparOkrsPorEixo() {
      const agrupado = new Map();
      (this.detalhePdm?.eixos || []).forEach((eixo) => {
        const idEixo = this.obterIdEixo(eixo);
        (eixo.okrs || []).forEach((okr) => {
          const destino = okr.eixoId || idEixo;
          if (!agrupado.has(destino)) {
            agrupado.set(destino, []);
          }
          agrupado.get(destino).push(okr);
        });
      });
      return agrupado;
    },
    validarOkrsAntesSalvar(okrs) {
      for (const okr of okrs || []) {
        const tituloObjetivo = (okr.titulo || "").trim();
        const possuiResultadoPreenchido = (okr.resultados || []).some(
          (resultado) => (resultado.titulo || "").trim()
        );
        if (!tituloObjetivo && possuiResultadoPreenchido) {
          throw new Error(
            "Preencha o objetivo estrategico antes de salvar seus KRs."
          );
        }
        for (const resultado of okr.resultados || []) {
          if (!tituloObjetivo && !(resultado.titulo || "").trim()) {
            continue;
          }
          if (!(resultado.titulo || "").trim()) {
            throw new Error(
              "Preencha a descricao dos KRs ou remova os itens vazios antes de salvar."
            );
          }
        }
      }
    },
    async processarExclusoesOkrsEixo(idPdm, idEixo) {
      const resultadosRemovidos = this.okrsResultadosRemovidos.filter(
        (item) => String(item.idEixo) === String(idEixo)
      );

      for (const item of resultadosRemovidos) {
        // eslint-disable-next-line no-await-in-loop
        await excluirResultadoOkr(
          idPdm,
          idEixo,
          item.idObjetivo,
          item.idResultado
        );
      }

      this.okrsResultadosRemovidos = this.okrsResultadosRemovidos.filter(
        (item) => String(item.idEixo) !== String(idEixo)
      );

      const objetivosRemovidos = this.okrsObjetivosRemovidos.filter(
        (item) => String(item.idEixo) === String(idEixo)
      );

      for (const item of objetivosRemovidos) {
        // eslint-disable-next-line no-await-in-loop
        await excluirObjetivoOkr(idPdm, idEixo, item.idObjetivo);
      }

      this.okrsObjetivosRemovidos = this.okrsObjetivosRemovidos.filter(
        (item) => String(item.idEixo) !== String(idEixo)
      );
    },
    async salvarOkrsParaEixo(idPdm, eixo, okrs) {
      if (!idPdm || !eixo) return;
      const idEixo = this.obterIdEixo(eixo);
      this.validarOkrsAntesSalvar(okrs);
      await this.processarExclusoesOkrsEixo(idPdm, idEixo);
      const itensMensuracaoAtualizados = [];

      for (const okr of okrs || []) {
        let idObjetivo = this.obterIdObjetivoPersistido(okr);
        const tituloObjetivo = (okr.titulo || "").trim();
        if (!idObjetivo && tituloObjetivo) {
          const { data: objetivoCriado } = await criarObjetivoOkr(
            idPdm,
            idEixo,
            {
              texto: tituloObjetivo,
              status: okr.status || "Planejamento",
            }
          );
          idObjetivo = objetivoCriado?.idObjetivo || objetivoCriado?.id;
          if (idObjetivo) {
            this.$set(okr, "id", idObjetivo);
            this.$set(okr, "idObjetivo", idObjetivo);
          }
        } else if (idObjetivo && tituloObjetivo) {
          await atualizarObjetivoOkr(idPdm, idEixo, idObjetivo, {
            texto: tituloObjetivo,
            status: okr.status || "Planejamento",
          });
        }

        if (!idObjetivo) continue;

        for (const resultado of okr.resultados || []) {
          const tituloResultado = (resultado.titulo || "").trim();
          if (!tituloResultado) continue;
          const idResultado = this.obterIdResultadoPersistido(resultado);
          const percentualAtual = this.normalizarPercentual(
            resultado.percentual || 0
          );
          const statusAtual = resultado.status || "Planejamento";
          const payloadResultado = {
            texto: tituloResultado,
            status: statusAtual,
            percentualAtingido: percentualAtual,
          };

          if (idResultado) {
            await atualizarResultadoOkr(
              idPdm,
              idEixo,
              idObjetivo,
              idResultado,
              payloadResultado
            );
            if (
              this.resultadoOkrTeveMensuracaoAlterada(
                resultado,
                percentualAtual,
                statusAtual
              )
            ) {
              itensMensuracaoAtualizados.push({
                idResultado,
                status: statusAtual,
                percentualAtingido: percentualAtual,
              });
            }
          } else {
            const { data: resultadoCriado } = await criarResultadoOkr(
              idPdm,
              idEixo,
              idObjetivo,
              payloadResultado
            );
            const novoId =
              resultadoCriado?.idResultado || resultadoCriado?.id || null;
            if (novoId) {
              this.$set(resultado, "id", novoId);
              this.$set(resultado, "idResultado", novoId);
            }
          }
        }
      }
      if (itensMensuracaoAtualizados.length) {
        await registrarMensuracaoOkr(idPdm, {
          dataReferencia: new Date().toISOString().slice(0, 10),
          itens: itensMensuracaoAtualizados,
        });
      }
      await this.carregarDetalhePdm(idPdm, idEixo);
    },
    resultadoOkrTeveMensuracaoAlterada(resultado, percentualAtual, statusAtual) {
      const percentualOriginal = this.normalizarPercentual(
        resultado?.percentualOriginal ?? resultado?.percentual ?? 0
      );
      const statusOriginal = resultado?.statusOriginal || resultado?.status || "";
      return (
        percentualOriginal !== percentualAtual ||
        String(statusOriginal) !== String(statusAtual || "")
      );
    },
    mapearOkrParaPayload(okr) {
      return {
        id: okr.id || null,
        referencia: okr.referencia || okr.clientId || null,
        titulo: okr.titulo,
        status: okr.status,
        resultados: (okr.resultados || []).map((resultado) => ({
          id: resultado.id || null,
          referencia: resultado.referencia || resultado.clientId || null,
          titulo: resultado.titulo,
          status: resultado.status,
          percentual: resultado.percentual,
        })),
        mensuracoes: (okr.mensuracoes || []).map((mensuracao) => ({
          id: mensuracao.id || null,
          data: mensuracao.data,
          resultados: (mensuracao.resultados || []).map((resultado) => ({
            idResultado: resultado.idResultado || null,
            referenciaResultado:
              resultado.referenciaResultado || resultado.referencia || null,
            percentual: resultado.percentual,
          })),
        })),
      };
    },
    abrirProjeto(projeto) {
      const idProjeto = projeto?.idProjeto || projeto?.id;
      if (!idProjeto) return;
      this.$router.push({
        name: "gestao-projetos.detalhe",
        params: { idProjeto },
      });
    },
    formatarPeriodo(inicio, fim) {
      const inicioFmt = inicio
        ? new Date(inicio).toLocaleDateString("pt-BR")
        : "—";
      const fimFmt = fim ? new Date(fim).toLocaleDateString("pt-BR") : "—";
      return `${inicioFmt} até ${fimFmt}`;
    },
    formatarPercentual(valor) {
      const numero = Number(valor);
      if (!Number.isFinite(numero)) return "0%";
      return `${Math.max(0, Math.min(100, numero)).toFixed(0)}%`;
    },
    formatarDataInput(valor) {
      if (!valor) return "";
      if (typeof valor === "string") {
        return valor.length > 10 ? valor.slice(0, 10) : valor;
      }
      try {
        return new Date(valor).toISOString().slice(0, 10);
      } catch (error) {
        return "";
      }
    },
    abrirAcaoPdm(acao) {
      if (!this.detalhePdm) return;
      if (acao === "excluir" && !this.podeExcluirPdm) {
        this.exibirErro(
          "Não é possível excluir um plano com projetos vinculados."
        );
        return;
      }
      const nome =
        acao === "editar"
          ? "gestao-projetos.pdm.editar"
          : "gestao-projetos.pdm.excluir";
      this.$router.push({
        name: nome,
        params: { idPdm: this.obterIdPdm(this.detalhePdm) },
      });
    },
    fecharAcaoPdm() {
      this.modalEdicaoAberta = false;
      this.modalExclusaoAberta = false;
      if (
        this.$route?.name &&
        this.$route.name.startsWith("gestao-projetos.pdm.") &&
        this.$route.name !== "gestao-projetos.pdm"
      ) {
        this.$router.push({ name: "gestao-projetos.pdm" });
      }
    },
    async atualizarPdmSelecionado(opcoes = {}) {
      if (!this.detalhePdm) return;
      const { silencioso = false, fecharModal = true } = opcoes || {};
      const idPdm = this.obterIdPdm(this.detalhePdm);
      if (
        !this.validarPeriodo(
          this.formEdicaoPdm.periodoInicio,
          this.formEdicaoPdm.periodoFim,
          "edicao"
        )
      ) {
        return;
      }
      try {
        this.processandoAcao = true;
        const payload = { ...this.formEdicaoPdm };
        const { data } = await atualizarPdmMunicipal(idPdm, payload);
        const atualizado = data || payload;
        this.detalhePdm = { ...this.detalhePdm, ...atualizado };
        const indice = this.pdms.findIndex(
          (pdm) => this.obterIdPdm(pdm) === idPdm
        );
        if (indice >= 0) {
          const itemAtual = { ...this.pdms[indice], ...atualizado };
          this.$set(this.pdms, indice, itemAtual);
        }
        if (!silencioso) {
          this.exibirSucesso("Plano municipal atualizado com sucesso!");
        }
        if (fecharModal) {
          this.fecharAcaoPdm();
        }
      } catch (error) {
        if (!silencioso) {
          this.exibirErro("Não foi possível atualizar o plano municipal.");
        }
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] atualizar pdm", error);
      } finally {
        this.processandoAcao = false;
      }
    },
    async excluirPdmSelecionado() {
      if (!this.detalhePdm || !this.podeExcluirPdm) return;
      const idPdm = this.obterIdPdm(this.detalhePdm);
      try {
        this.processandoAcao = true;
        await excluirPdmMunicipal(idPdm);
        this.pdms = this.pdms.filter((pdm) => this.obterIdPdm(pdm) !== idPdm);
        this.exibirSucesso("Plano municipal excluído com sucesso!");
        this.fecharAcaoPdm();
        if (this.pdms.length) {
          await this.selecionarPdm(this.pdms[0]);
        } else {
          this.detalhePdm = null;
          this.eixoSelecionado = null;
        }
      } catch (error) {
        this.exibirErro("Não foi possível excluir o plano municipal.");
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] excluir pdm", error);
      } finally {
        this.processandoAcao = false;
      }
    },
    exibirErro(mensagem) {
      this.definirAlerta("erro", mensagem);
      this.$toasted && this.$toasted.error(mensagem);
    },
    exibirSucesso(mensagem) {
      this.definirAlerta("sucesso", mensagem);
      this.$toasted && this.$toasted.success(mensagem);
    },
    definirAlerta(tipo, mensagem) {
      this.alerta = {
        tipo,
        mensagem,
      };
    },
    limparErroPeriodo(contexto, limparMensagem = true) {
      const mapa = {
        novo: "periodoNovoPdm",
        edicao: "periodoEdicao",
        vinculo: "periodoVinculo",
      };
      const chave = mapa[contexto];
      if (chave) {
        this.erros = { ...this.erros, [chave]: false };
      }
      if (limparMensagem && this.alerta.tipo === "erro") {
        this.definirAlerta("", "");
      }
    },
    validarPeriodo(inicio, fim, contexto) {
      this.limparErroPeriodo(contexto, false);
      if (!inicio || !fim) {
        return true;
      }
      const inicioData = new Date(inicio);
      const fimData = new Date(fim);
      const chaveErro =
        contexto === "novo"
          ? "periodoNovoPdm"
          : contexto === "edicao"
          ? "periodoEdicao"
          : "periodoVinculo";
      if (
        Number.isNaN(inicioData.getTime()) ||
        Number.isNaN(fimData.getTime())
      ) {
        this.erros = { ...this.erros, [chaveErro]: true };
        this.exibirErro("Informe datas válidas no formato dia/mês/ano.");
        return false;
      }
      if (inicioData > fimData) {
        this.erros = { ...this.erros, [chaveErro]: true };
        this.exibirErro(
          "A data final deve ser igual ou posterior à data inicial."
        );
        return false;
      }
      this.erros = { ...this.erros, [chaveErro]: false };
      if (this.alerta.tipo === "erro") {
        this.definirAlerta("", "");
      }
      return true;
    },
    areaChaveIndisponivel(nome) {
      const atual = this.normalizarAreaChave(this.formEdicaoEixo.nome);
      const normalizado = this.normalizarAreaChave(nome);
      if (normalizado === atual) return false;
      return this.areasChaveDisponiveis.every(
        (area) =>
          this.normalizarAreaChave(area) !== this.normalizarAreaChave(nome)
      );
    },
    normalizarAreaChave(valor) {
      return (valor || "").trim().toLowerCase();
    },
    alternarListaTodosMunicipios() {
      if (this.mostrarTodosMunicipios) {
        this.filtros.idMunicipio = undefined;
        this.municipioFiltro.municipio = null;
      }
    },
  },
};
</script>

<style scoped>
.pdm-gestao {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.pdm-gestao--bloqueado {
  position: relative;
}

.overlay-processando-okr {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.35);
}

.overlay-processando-okr__conteudo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 28px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.2);
}

.overlay-processando-okr__conteudo p {
  margin: 0;
  color: #0f172a;
  font-size: 0.95rem;
}

.overlay-processando-okr__spinner {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 3px solid #c7d2e2;
  border-top-color: #1d4ed8;
  animation: girar-overlay-okr 0.8s linear infinite;
}

@keyframes girar-overlay-okr {
  to {
    transform: rotate(360deg);
  }
}

.alerta {
  border-radius: 10px;
  padding: 10px 14px;
  border: 1px solid #c7d2e2;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.9rem;
}

.alerta[data-tipo="erro"] {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.alerta[data-tipo="sucesso"] {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #166534;
}

.cabecalho {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}

.cabecalho h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #0f172a;
}

.indicadores {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  padding: 6px 12px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #1d4ed8;
  font-weight: 600;
  font-size: 0.8rem;
}

.tag.secundario {
  color: #0f766e;
  background: #d1fae5;
}

.filtros-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;
}

.filtros-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;
}

.filtros-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filtros-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.4;
}

.filtros-clear {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.filtros-clear:hover {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
}

.filtros-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: end;
}

.filtro-campo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filtro-campo label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filtro-campo label svg {
  color: #0074cc;
}

.filtro-input-wrapper {
  position: relative;
}

.filtro-campo :deep(.v-input__control),
.filtro-campo :deep(.v-field) {
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.filtro-campo :deep(.v-field:hover) {
  border-color: #0074cc;
  box-shadow: 0 2px 6px rgba(0, 116, 204, 0.1);
}

.filtro-campo :deep(.v-field--focused) {
  border-color: #0074cc;
  box-shadow: 0 0 0 3px rgba(0, 116, 204, 0.1);
}

.filtro-campo :deep(.v-field__input) {
  padding: 12px 16px;
  font-size: 0.95rem;
}

.filtro-campo :deep(.combobox-municipio .v-field) {
  min-height: 48px;
}

.filtro-campo :deep(.combobox-municipio .v-field__input),
.filtro-campo :deep(.combobox-municipio input) {
  min-height: 48px;
  padding: 8px 16px;
}

.filtro-campo-checkbox {
  justify-content: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  transition: all 0.2s ease;
  font-weight: 500;
  color: #374151;
}

.checkbox-label:hover {
  border-color: #0074cc;
  background: #f8fafc;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.checkbox-label input[type="checkbox"]:checked {
  background: #0074cc;
  border-color: #0074cc;
}

.checkbox-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.checkbox-text svg {
  color: #0074cc;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.checkbox-label input[type="checkbox"]:checked ~ .checkbox-text svg {
  opacity: 1;
}

.checkbox-description {
  margin-top: 4px;
  color: #64748b;
  font-size: 0.8rem;
  margin-left: 4px;
}

.filtros {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  background: #ffffff;
  border: 1px solid #d6dde9;
  border-radius: 12px;
  padding: 16px;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.campo-checkbox {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #334155;
}

.campo-checkbox input {
  width: 16px;
  height: 16px;
}

.campo label {
  font-size: 0.85rem;
  color: #334155;
  font-weight: 600;
}

.campo select,
.campo input {
  border: 1px solid #c7d2e2;
  border-radius: 8px;
  padding: 8px 10px;
  background: #f8fafc;
  font: inherit;
}

.campo :deep(.v-input__slot),
.campo :deep(.v-field) {
  border: 1px solid #c7d2e2;
  border-radius: 8px;
  background: #f8fafc;
}

.campo :deep(.combobox-municipio .v-field) {
  min-height: 44px;
}

.campo :deep(.combobox-municipio .v-field__input),
.campo :deep(.combobox-municipio input) {
  min-height: 44px;
  padding: 6px 12px;
}

.conteudo {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.painel-pdms-novo {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.pdms-section {
  margin-bottom: 24px;
}

.lista-header {
  margin-bottom: 16px;
}

.lista-header h3 {
  margin: 0 0 4px 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
}

.lista-header small {
  color: #64748b;
  font-size: 0.9rem;
}

.divider {
  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    #e2e8f0 20%,
    #e2e8f0 80%,
    transparent
  );
  margin: 24px 0;
}

.novo-pdm-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-header {
  margin-bottom: 8px;
}

.form-header h4 {
  margin: 0 0 4px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}

.form-header small {
  color: #64748b;
  font-size: 0.85rem;
}

.novo-pdm-container {
  margin-top: 8px;
}

.btn-novo-pdm {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #374151;
  font-size: 0.95rem;
}

.btn-novo-pdm:hover {
  border-color: #0074cc;
  border-style: solid;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 116, 204, 0.1);
}

.btn-novo-pdm svg:first-child {
  color: #94a3b8;
  transition: all 0.2s ease;
}

.btn-novo-pdm:hover svg:first-child {
  color: #0074cc;
  transform: scale(1.1);
}

.btn-content {
  flex: 1;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.btn-title {
  font-weight: 600;
  color: #1e293b;
}

.btn-description {
  color: #64748b;
  font-size: 0.85rem;
}

.btn-novo-pdm svg:last-child {
  color: #94a3b8;
  transition: all 0.2s ease;
}

.btn-novo-pdm:hover svg:last-child {
  color: #0074cc;
  transform: translateX(4px);
}

.novo-pdm-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.form-header h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}

.btn-fechar {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
}

.btn-fechar:hover {
  background: #e2e8f0;
  color: #374151;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-cancelar {
  background: #f8fafc;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #374151;
  font-weight: 500;
}

.btn-cancelar:hover {
  background: #f1f5f9;
  border-color: #9ca3af;
}

.form-campos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.periodo-campos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 640px) {
  .periodo-campos {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.campo-form {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
}

.campo-form input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 14px;
  background: #ffffff;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.campo-form input:focus {
  outline: none;
  border-color: #0074cc;
  box-shadow: 0 0 0 3px rgba(0, 116, 204, 0.1);
}

.campo-form input.invalido {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.btn-adicionar {
  background: #0074cc;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
}

.btn-adicionar:hover:not(:disabled) {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 116, 204, 0.3);
}

.btn-adicionar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-adicionar svg {
  transition: transform 0.2s ease;
}

.btn-adicionar:hover:not(:disabled) svg {
  transform: scale(1.1);
}

.empty-state {
  text-align: center;
  padding: 32px 16px;
  color: #64748b;
}

.select-municipio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 16px;
  text-align: center;
  color: #64748b;
}

.select-municipio svg {
  color: #94a3b8;
}

.select-municipio p {
  margin: 0;
  font-size: 0.95rem;
}

.pdms {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pdms li {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.pdms li:hover {
  border-color: #0074cc;
  box-shadow: 0 4px 12px rgba(0, 116, 204, 0.12);
  transform: translateY(-2px);
}

.pdms li.ativo {
  border-color: #0074cc;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  box-shadow: 0 4px 16px rgba(0, 116, 204, 0.15);
  transform: translateY(-1px);
}

.pdm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px;
  gap: 16px;
}

.pdm-info {
  flex: 1;
  min-width: 0;
}

.pdm-nome {
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
}

.pdms li.ativo .pdm-nome {
  color: #0074cc;
}

.pdm-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pdm-periodo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.pdm-periodo svg {
  color: #94a3b8;
}

.pdm-status {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #f1f5f9;
  color: #475569;
}

.pdm-status[data-status="planejado"] {
  background: #dbeafe;
  color: #1e40af;
}

.pdm-status[data-status="em andamento"] {
  background: #fef3c7;
  color: #92400e;
}

.pdm-status[data-status="concluído"] {
  background: #dcfce7;
  color: #166534;
}

.pdm-status[data-status="concluido"] {
  background: #dcfce7;
  color: #166534;
}

.pdm-status[data-status="suspenso"] {
  background: #ede9fe;
  color: #5b21b6;
}

.pdm-status[data-status="cancelado"] {
  background: #fee2e2;
  color: #991b1b;
}

.pdm-actions {
  display: flex;
  align-items: center;
  color: #94a3b8;
  transition: all 0.2s ease;
}

.pdms li:hover .pdm-actions {
  color: #0074cc;
  transform: translateX(2px);
}

.pdm-municipio {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
}

.pdm-municipio svg {
  color: #94a3b8;
}

.pdms li.ativo .pdm-municipio {
  background: rgba(239, 246, 255, 0.5);
  border-top-color: rgba(0, 116, 204, 0.1);
}

.formulario {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.formulario input,
.formulario textarea,
.formulario select {
  border: 1px solid #c7d2e2;
  border-radius: 8px;
  padding: 8px 10px;
  background: #f8fafc;
}

.formulario button {
  align-self: flex-start;
  border-radius: 8px;
  border: 1px solid #1d4ed8;
  background: #1d4ed8;
  color: #ffffff;
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 600;
}

.detalhe-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
}

.detalhe-controles {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.acoes-pdm {
  display: flex;
  gap: 8px;
}

.botao-acao {
  border-radius: 6px;
  border: 1px solid #1d4ed8;
  background: transparent;
  color: #1d4ed8;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 600;
}

.botao-acao.perigoso {
  border-color: #dc2626;
  color: #dc2626;
}

.grupo-botoes-inline {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.confirmacao-exclusao {
  border: 1px solid #fecaca;
  background: #fee2e2;
  border-radius: 10px;
  padding: 12px;
  color: #7f1d1d;
}

.badge {
  padding: 4px 10px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #1d4ed8;
  font-weight: 600;
}

.colunas {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 16px;
}

.acoes-eixo-rapidas {
  display: flex;
  align-items: center;
  gap: 8px;
}

.botao-okr-rapido {
  padding: 4px 10px;
  font-size: 0.85rem;
}

.lista-eixos {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lista-eixos li {
  border: 1px solid #d6dde9;
  border-radius: 10px;
  padding: 12px;
  background: #f8fafc;
  cursor: pointer;
}

.lista-eixos li.ativo {
  border-color: #1d4ed8;
  background: #eff6ff;
}

.titulo-secao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.titulo-secao button {
  border-radius: 6px;
  border: 1px solid #1d4ed8;
  background: transparent;
  color: #1d4ed8;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 600;
}

.menu-acoes-eixo {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.okr-painel__cabecalho {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.okr-painel__cabecalho p {
  margin: 0;
  color: #334155;
}

.okr-painel__ajuda {
  font-size: 0.9rem;
}

.okr-lista {
  border: 1px solid #d6dde9;
  border-radius: 10px;
  padding: 12px;
  background: #f8fafc;
  overflow: hidden;
}

.okr-cadastro-card {
  border: 1px solid #d6dde9;
  border-radius: 10px;
  padding: 10px;
  background: #f8fafc;
}

.okr-vazio {
  margin: 0;
  color: #64748b;
}

.cartao-okr {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 10px;
  background: #ffffff;
  margin-top: 10px;
}

.cartao-okr__cabecalho {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
}

.kr-item {
  width: 100%;
  text-align: left;
  border: 1px solid #d6dde9;
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  color: #0f172a;
  white-space: normal;
  align-items: flex-start;
}

.kr-item span {
  overflow-wrap: anywhere;
}

.kr-item span:last-child {
  flex-shrink: 0;
  margin-left: 8px;
}

.kr-item:hover {
  border-color: #1d4ed8;
  background: #eff6ff;
  color: #0f172a;
}

.okr-alerta {
  margin: 0 0 10px 0;
  padding: 10px;
  border-radius: 8px;
  background: #fef3c7;
  color: #92400e;
}

.placeholder {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 24px;
  text-align: center;
  color: #475569;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 30;
  backdrop-filter: blur(4px);
}

.modal-caixa {
  background: #ffffff;
  border: 1px solid #d6dde9;
  border-radius: 16px;
  width: min(500px, 100%);
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-height: 90vh;
  overflow: hidden;
}

.modal-edicao {
  width: min(580px, 100%);
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.modal-header-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
}

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #004b87;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modal-title-group h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.25;
}

.modal-descricao {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.4;
}

.modal-close-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.modal-close-btn:hover {
  background: #f1f5f9;
  color: #374151;
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  flex: 1;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-label svg {
  color: #6b7280;
  flex-shrink: 0;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  background: white;
  transition: all 0.15s ease;
}

.form-input:focus {
  outline: none;
  border-color: #004b87;
  box-shadow: 0 0 0 3px rgba(0, 75, 135, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.form-input.input-error {
  border-color: #ef4444;
  background: #fef2f2;
}

.form-input.input-error:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title svg {
  color: #004b87;
  flex-shrink: 0;
}

.date-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.error-message {
  color: #ef4444;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.error-message svg {
  flex-shrink: 0;
}

.modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-secondary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-secondary:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  background: #004b87;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 140px;
  justify-content: center;
}

.btn-primary:hover:not(:disabled) {
  background: #003d73;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-primary .spinner {
  animation: spin 1s linear infinite;
}

/* Estilos específicos para modal de exclusão */
.modal-exclusao {
  width: min(520px, 100%);
}

.modal-icon-danger {
  background: #ef4444;
  color: white;
}

.warning-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 1px solid #fbbf24;
  background: #fef3c7;
  border-radius: 8px;
  color: #92400e;
}

.warning-message svg {
  color: #f59e0b;
  flex-shrink: 0;
  margin-top: 2px;
}

.warning-message p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.warning-message p:first-child {
  margin-bottom: 4px;
}

.error-message-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 1px solid #f87171;
  background: #fef2f2;
  border-radius: 8px;
  color: #991b1b;
}

.error-message-box svg {
  color: #ef4444;
  flex-shrink: 0;
  margin-top: 2px;
}

.error-message-box p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.error-message-box p:first-child {
  margin-bottom: 4px;
}

.btn-danger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  background: #ef4444;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 160px;
  justify-content: center;
}

.btn-danger:hover:not(:disabled) {
  background: #dc2626;
}

.btn-danger:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-danger .spinner {
  animation: spin 1s linear infinite;
}

/* Estilos para novo formulário de área chave */
.nova-area-container {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.nova-area-header {
  background: linear-gradient(135deg, #004b87 0%, #003d73 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.nova-area-icon {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nova-area-title h4 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
}

.nova-area-title p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.nova-area-form {
  padding: 24px;
}

.nova-area-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  background: white;
  transition: all 0.15s ease;
  cursor: pointer;
}

.form-select:focus {
  outline: none;
  border-color: #004b87;
  box-shadow: 0 0 0 3px rgba(0, 75, 135, 0.1);
}

.form-select:disabled {
  background: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  background: white;
  transition: all 0.15s ease;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.form-textarea:focus {
  outline: none;
  border-color: #004b87;
  box-shadow: 0 0 0 3px rgba(0, 75, 135, 0.1);
}

.form-textarea::placeholder {
  color: #9ca3af;
}

.warning-message-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  color: #92400e;
  font-size: 14px;
  margin-bottom: 16px;
}

.warning-message-inline svg {
  color: #f59e0b;
  flex-shrink: 0;
}

.nova-area-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
}

.btn-cancel {
  min-width: 100px;
}

.btn-create {
  min-width: 180px;
}

.botao-texto {
  border: none;
  background: transparent;
  color: #1d4ed8;
  font-weight: 600;
  cursor: pointer;
}

.botao-primario {
  border-radius: 8px;
  border: 1px solid #1d4ed8;
  background: #1d4ed8;
  color: #ffffff;
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 600;
}

.botao-primario.perigoso {
  border-color: #dc2626;
  background: #dc2626;
}

.aviso {
  background: #fee2e2;
  border-radius: 8px;
  padding: 10px;
  color: #b91c1c;
}

@media (max-width: 1200px) {
  .colunas {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .painel-pdms-novo,
  .detalhe {
    padding: 16px;
  }

  .filtros-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros-clear {
    align-self: flex-start;
  }

  .filtros-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .filtros-container {
    padding: 16px;
  }

  .divider {
    margin: 16px 0;
  }

  .form-campos {
    gap: 12px;
  }
}

/* Estilos para expansão inline dos PDMs */
.pdm-item {
  &.expandido {
    .pdm-header {
      border-bottom: 1px solid #e5e7eb;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}

.pdm-actions svg {
  transition: transform 0.15s ease;

  &.rotated {
    transform: rotate(90deg);
  }
}

/* Animação de expansão */
.expand-enter-active {
  transition: opacity 0.1s ease;
}

.expand-leave-active {
  transition: none;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
}

/* Conteúdo expandido do PDM */
.pdm-detalhe {
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
  padding: 24px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

/* Loading do PDM */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 40px 20px;
}

.loading-spinner {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #6b7280;
  font-size: 14px;
}

.spinner {
  animation: spin 1s linear infinite;
  color: #004b87;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.pdm-detalhe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;

  .pdm-detalhe-info {
    display: flex;
    align-items: center;
    gap: 16px;

    .badge {
      background: #004b87;
      color: white;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
    }
  }

  .acoes-pdm {
    display: flex;
    gap: 12px;

    .botao-acao {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      border: 1px solid #d1d5db;
      background: white;
      color: #374151;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.1s ease, border-color 0.1s ease;

      &:hover:not(:disabled) {
        background: #f9fafb;
        border-color: #9ca3af;
      }

      &.perigoso {
        color: #dc2626;
        border-color: #fca5a5;

        &:hover:not(:disabled) {
          background: #fef2f2;
          border-color: #f87171;
        }
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.pdm-detalhe-content {
  .eixos-inline {
    .titulo-secao {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      h4 {
        margin: 0;
        color: #1f2937;
        font-size: 18px;
        font-weight: 600;
      }

      .btn-nova-area {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        background: #004b87;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.1s ease;

        &:hover:not(:disabled) {
          background: #003d73;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}

.area-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.area-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.area-card.ativo {
  border-color: #10b981;
  background: #f0fdf4;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);
}

.area-card.ativo .area-card-header strong {
  color: #059669;
}

.area-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;

  strong {
    color: #1f2937;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
  }

  .badge {
    &.secundario {
      background: #f3f4f6;
      color: #6b7280;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
    }
  }
}

.area-card-description {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}

.area-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;

  .btn-action {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #d1d5db;
    background: white;
    color: #374151;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .btn-action:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #3b82f6;
    color: #1e40af;
  }

  .btn-action.btn-danger {
    color: #dc2626;
    border-color: #fca5a5;
  }

  .btn-action.btn-danger:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #f87171;
  }

  .btn-action:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

/* === CONTAINER DAS ÁREAS === */
.areas-premium-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
}

.area-title-section {
  width: 100%;
  cursor: pointer;
}

.area-meta-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.expand-icon {
  transition: transform 0.2s ease !important;
  color: #6b7280 !important;
}

.expand-icon.rotated {
  transform: rotate(180deg);
  color: #10b981 !important;
}

/* === SEÇÃO OKRs === */
.area-okrs-premium-section {
  background: #f8fafc;
  margin: 16px -20px -20px -20px;
  padding: 20px;
  border-top: 2px solid #e5e7eb;
}

.okrs-premium-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.okrs-title-premium {
  display: flex;
  align-items: center;
  gap: 12px;
}

.okr-icon-wrapper {
  width: 40px;
  height: 40px;
  background: #10b981;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.okrs-title-text h4 {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.okrs-title-text p {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.okrs-premium-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-okr-action {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-okr-action.primary {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.btn-okr-action.success {
  background: #10b981;
  color: white;
  border-color: #10b981;
}

.btn-okr-action:hover:not(:disabled) {
  opacity: 0.9;
}

.btn-okr-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/* === ANIMAÇÕES === */
.okrs-premium-expand-enter-active,
.okrs-premium-expand-leave-active {
  transition: all 0.3s ease;
}

.okrs-premium-expand-enter-from,
.okrs-premium-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.okrs-premium-expand-enter-to,
.okrs-premium-expand-leave-from {
  opacity: 1;
  max-height: 500px;
}

.formulario-inline {
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;

  .form-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 16px;
    margin-bottom: 16px;

    label {
      display: flex;
      flex-direction: column;
      gap: 6px;
      color: #374151;
      font-size: 14px;
      font-weight: 500;

      select,
      textarea {
        padding: 10px 12px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 14px;
        transition: border-color 0.1s ease;

        &:focus {
          outline: none;
          border-color: #004b87;
          box-shadow: 0 0 0 3px rgba(0, 75, 135, 0.1);
        }
      }

      textarea {
        resize: vertical;
        font-family: inherit;
      }
    }
  }

  .form-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-primary {
      padding: 10px 20px;
      background: #004b87;
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.1s ease;

      &:hover:not(:disabled) {
        background: #003d73;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .ajuda {
      color: #6b7280;
      font-size: 13px;
      font-style: italic;
    }
  }
}

/* Responsividade para expansão inline */
@media (max-width: 768px) {
  .pdm-detalhe {
    padding: 16px;
  }

  .pdm-detalhe-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    .acoes-pdm {
      width: 100%;
      justify-content: flex-start;
    }
  }

  .areas-grid {
    grid-template-columns: 1fr;
  }

  .formulario-inline .form-row {
    grid-template-columns: 1fr;
  }
}

/* Loading da listagem de PDMs */
.loading-pdms {
  padding: 60px 20px;
  text-align: center;
}

.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner .spinner {
  animation: spin 1s linear infinite;
  color: #004b87;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #374151;
}

.loading-subtext {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

.swal2-modern-content {
  padding: 0 24px 24px 24px !important;
  margin: 0 !important;
  text-align: left !important;
}

/* Conteúdo do modal de exclusão */
.exclusao-modal-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.area-info {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  margin-bottom: 20px;
}

.area-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.area-details {
  flex: 1;
}

.area-name {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.area-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.warning-box {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #f59e0b;
  border-radius: 10px;
  padding: 16px;
  margin: 16px 0;
}

.warning-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #92400e;
  margin-bottom: 8px;
  font-size: 14px;
}

.warning-box p {
  margin: 0;
  color: #92400e;
  font-size: 14px;
  line-height: 1.5;
}

.danger-warning {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%);
  border: 1px solid #ef4444;
  border-radius: 10px;
  margin-top: 16px;
  font-size: 14px;
  color: #b91c1c;
  font-weight: 500;
}

/* Botões modernos */
.swal2-modern-actions {
  margin: 20px 24px 24px 24px !important;
  gap: 12px !important;
}

.swal2-modern-confirm {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3) !important;
  transition: all 0.2s ease !important;
}

.swal2-modern-confirm:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%) !important;
  box-shadow: 0 6px 8px -2px rgba(220, 38, 38, 0.4) !important;
  transform: translateY(-1px) !important;
}

.swal2-modern-cancel {
  background: white !important;
  color: #6b7280 !important;
  border: 2px solid #d1d5db !important;
  border-radius: 10px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
}

.swal2-modern-cancel:hover {
  background: #f9fafb !important;
  border-color: #9ca3af !important;
  color: #374151 !important;
  transform: translateY(-1px) !important;
}

/* Modal de Loading */
.swal2-loading-popup {
  border-radius: 16px !important;
  padding: 32px !important;
  background: white !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.swal2-loading-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  margin-bottom: 20px !important;
}

.loading-content {
  text-align: center;
  padding: 20px 0;
}

.loading-icon {
  margin-bottom: 16px;
}

.loading-text {
  font-size: 16px;
  color: #374151;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.loading-subtitle {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
}

/* Modal de Sucesso */
.swal2-success-popup {
  border-radius: 16px !important;
  padding: 32px !important;
  background: linear-gradient(to bottom, #ffffff, #f0fdf4) !important;
  border: 1px solid #bbf7d0 !important;
}

.swal2-success-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #065f46 !important;
  margin-bottom: 20px !important;
}

.success-content {
  text-align: center;
  padding: 16px 0;
}

.success-icon {
  margin-bottom: 16px;
}

.success-text {
  font-size: 16px;
  color: #047857;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.success-subtitle {
  font-size: 13px;
  color: #059669;
  margin: 0;
}

.swal2-success-confirm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  margin-top: 16px !important;
}

.swal2-success-timer {
  background: #10b981 !important;
}

/* Modal de Erro */
.swal2-error-popup {
  border-radius: 16px !important;
  padding: 32px !important;
  background: linear-gradient(to bottom, #ffffff, #fef2f2) !important;
  border: 1px solid #fecaca !important;
}

.swal2-error-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #b91c1c !important;
  margin-bottom: 20px !important;
}

.error-content {
  text-align: center;
  padding: 16px 0;
}

.error-icon {
  margin-bottom: 16px;
}

.error-text {
  font-size: 16px;
  color: #dc2626;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.error-subtitle {
  font-size: 13px;
  color: #ef4444;
  margin: 0;
  line-height: 1.4;
}

.swal2-error-confirm {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  margin-top: 16px !important;
}

/* Ícone personalizado */
.swal2-icon.swal2-question {
  border-color: #f59e0b !important;
  color: #f59e0b !important;
}

/* === ESTILOS ACORDEÃO DE ÁREAS === */
.areas-accordion {
  margin-top: 20px;
}

.area-accordion-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
}

.area-header {
  background: #f9fafb;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #e5e7eb;
}

.area-header:hover {
  background: #f3f4f6;
}

.area-header.area-expanded {
  background: #ecfdf5;
  border-bottom-color: #a7f3d0;
}

.area-info {
  flex: 1;
  min-width: 0;
}

.area-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.area-title h5 {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.area-projetos-count {
  background: #e5e7eb;
  color: #6b7280;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.area-expanded .area-projetos-count {
  background: #a7f3d0;
  color: #065f46;
}

.area-description {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.area-no-description {
  font-style: italic;
  color: #9ca3af;
}

.area-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* === SEÇÃO OKRs EXPANSÍVEL - DESIGN PREMIUM === */
.area-okrs-section {
  background: linear-gradient(135deg, #fafbff 0%, #f0f4ff 100%);
  padding: 32px;
  border-top: 3px solid rgba(16, 185, 129, 0.2);
  position: relative;
}

.area-okrs-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #10b981, #059669, #047857);
}

.okrs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 20px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  border-radius: 12px;
  border: 1px solid rgba(16, 185, 129, 0.1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

.okrs-title {
  display: flex;
  align-items: center;
  position: relative;
}

.okrs-title h5 {
  background: linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.025em;
}

.okrs-actions {
  display: flex;
  gap: 16px;
}

.okrs-empty-state {
  text-align: center;
  padding: 60px 20px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.8) 0%,
    rgba(249, 250, 251, 0.8) 100%
  );
  border-radius: 16px;
  border: 2px dashed #d1d5db;
  color: #6b7280;
  transition: all 0.3s ease;
}

.okrs-empty-state:hover {
  border-color: #9ca3af;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.okrs-empty-state p {
  font-size: 17px;
  margin: 20px 0 32px 0;
  font-weight: 500;
}

/* === CARDS OKR - GLASSMORPHISM DESIGN === */
.okr-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.okr-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%);
  background-size: 200% 100%;
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.okr-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
  border-color: rgba(102, 126, 234, 0.4);
}

.okr-field-group {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 20px;
  align-items: end;
}

.okr-input-large {
  grid-column: 1 / -1;
  min-width: 0;
}

.okr-select-status {
  min-width: 0;
}

.okr-remove-btn {
  margin-top: 8px !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.okr-remove-btn:hover {
  transform: scale(1.05) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

/* === RESULTADOS - DESIGN PREMIUM === */
.okr-resultados {
  margin-top: 28px;
  padding-top: 28px;
  border-top: 2px solid rgba(209, 213, 219, 0.3);
  position: relative;
}

.okr-resultados::before {
  content: "";
  position: absolute;
  top: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #d1d5db 50%,
    transparent 100%
  );
}

.okr-resultados-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: linear-gradient(
    135deg,
    rgba(99, 102, 241, 0.05) 0%,
    rgba(139, 92, 246, 0.05) 100%
  );
  border-radius: 12px;
  border: 1px solid rgba(99, 102, 241, 0.1);
}

.okr-resultados-header h6 {
  background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 17px;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  letter-spacing: -0.025em;
}

.okr-resultado-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(100px, 140px) auto;
  gap: 16px;
  align-items: end;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(249, 250, 251, 0.9) 100%
  );
  backdrop-filter: blur(8px);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(229, 231, 235, 0.5);
  margin-bottom: 16px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.okr-resultado-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.okr-resultado-item:hover {
  transform: translateX(4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-color: rgba(102, 126, 234, 0.3);
}

.okr-resultado-item:hover::before {
  opacity: 1;
}

.resultado-titulo {
  grid-column: 1 / -1;
  min-width: 0;
}

.resultado-status {
  min-width: 0;
}

.resultado-percentual {
  min-width: 0;
}

/* === MENSURAÇÃO === */
.okr-mensuracao {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #d1d5db;
}

.okr-mensuracao-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.mensuracao-label {
  color: #6b7280;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.okr-historico-mensuracoes {
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #f8fbff;
  padding: 12px;
  margin-bottom: 16px;
}

.okr-historico-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0f4c81;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 8px;
}

.okr-historico-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid #e5edf7;
}

.okr-historico-item:first-of-type {
  border-top: none;
}

.okr-historico-item strong,
.okr-historico-valores span {
  color: #111827;
  font-size: 13px;
  font-weight: 700;
}

.okr-historico-item small {
  display: block;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.35;
}

.okr-historico-valores {
  min-width: 88px;
  text-align: right;
}

.okr-mensuracao-form {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
}

.mensuracao-form-title {
  color: #0369a1;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.mensuracao-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.mensuracao-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #bae6fd;
}

/* === ANIMAÇÕES === */
.okrs-expand-enter-active,
.okrs-expand-leave-active {
  transition: all 0.3s ease;
}

.okrs-expand-enter,
.okrs-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.okrs-expand-enter-to,
.okrs-expand-leave {
  opacity: 1;
  max-height: 1000px;
}

/* === RESPONSIVO === */
@media (max-width: 768px) {
  .area-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .area-actions {
    justify-content: stretch;
  }

  .area-actions .v-btn {
    flex: 1;
  }

  .okrs-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .okrs-actions {
    justify-content: stretch;
  }

  .okr-field-group {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .okr-card {
    padding: 16px 12px;
  }

  .okr-resultado-item {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }

  .okr-mensuracao-info {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .mensuracao-actions {
    justify-content: stretch;
  }

  .mensuracao-actions .v-btn {
    flex: 1;
  }
}
</style>
